export const header = {
    EN: {
        navigator: [
            {
                path: '',
                name: 'Home'
            },
            {
                name: 'Solution',
                block: true,
                show: false,
                level: '1',
                children: [
                    {
                        name: 'Urban space control system',
                        path: '/space'
                    },
                    {
                        path: '/service',
                        name: 'Low altitude service system'
                    },
                ]
            },
            // {
            //     name: 'Intelligent equipment',
            //     block: true,
            //     show: false,
            //     level: '1',
            //     children: [
            //         {
            //             path: '/observer',
            //             name: 'Observer'
            //         },
            //         {
            //             path: '/catcher',
            //             name: 'Catcher'
            //         },
            //         {
            //             path: '/collector',
            //             name: 'Collector'
            //         },
            //         {
            //             name: 'Modules',
            //             block: true,
            //             show: false,
            //             level: '2-1',
            //             children: [                            
            //                 {
            //                     title: 'Flight control module',
            //                 },{
            //                     path: '/AK1',
            //                     name: 'AK1'
            //                 },
            //                 {
            //                     path: '/AK2',
            //                     name: 'AK2'
            //                 },
            //                 {
            //                     path: '/AK3',
            //                     name: 'AK3'
            //                 },
            //                 {
            //                     title: 'Payload module',
            //                 },
            //                 {
            //                     path: '/C5',
            //                     name: 'Ling jing C5'
            //                 }
            //             ]
            //         },
            //     ]
            // },
            {
                path: '/about',
                name: 'About us'
            },
        ]
    },
    CN: {
        navigator: [
            {
                path: '',
                name: '首页'
            },
            {
                name: '低空服务',
                outer: true,
                path: 'https://www.airspace.cn/',
            },
            {
                name: '无人机装备',
                block: true,
                show: false,
                level: '1',
                children:[
                    {
                        path: '/observer',
                        name: '观测者'
                    },
                    {
                        path: '/catcher',
                        name: '守望者'
                    },
                    {
                        path: '/collector',
                        name: '采集者'
                    },
                    {
                        name: '系统模块',
                        block: true,
                        show: false,
                        level: '2-1',
                        children: [
                            {
                                title: '飞控模块',
                            },
                            {
                                path: '/AK1',
                                name: 'AK1'
                            },
                            {
                                path: '/AK2',
                                name: 'AK2'
                            },
                            {
                                path: '/AK3',
                                name: 'AK3'
                            },
                            {
                                title: '载荷模块',
                            },
                            {
                                path: '/c5',
                                name: '灵境 C5'
                            }
                        ]
                    }
                ]                
            },
            {
                name: '行业应用',
                path: '/service',
                // block: true,
                // show: false,
                // level: '1',
                // children: [
                //     {
                //         path: '/bigdataplatform',
                //         name: '城市数字孪生底座'
                //     },
                //     {
                //         path: '/space',
                //         name: '城市建设监管系统'
                //     },
                //     {
                //         path: '/service',
                //         name: '城市低空服务系统'
                //     },
                // ]
            },
            {
                name: '关于我们',
                block: true,
                show: false,
                level: '1',
                children:[
                    {
                        path: '/about',
                        name: '品牌故事'
                    },
                    {
                        path: '/contact',
                        name: '联系我们'
                    }
                ]
            },
        ]
    }
}

export const footer = {
    EN: ['PARTNERS', 'THE INVESTORS', `Copyright © ${ +new Date().getFullYear() } Airlook <span class="copyright_con"><div style="width:300px;margin:0 auto; padding:20px 0;">
    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502051796" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="/gongan.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 11010502051796号</p></a>
</div><a href="https://beian.miit.gov.cn/" target="_blank">Jing ICP No.16010436-2</a></span>`, 'About us', 'Business consulting', 'Technical consulting'],
    CN: ['合作伙伴', '资方伙伴', `Copyright © ${ +new Date().getFullYear() } Airlook <span class="copyright_con"><div style="width:300px;margin:0 auto; padding:20px 0;">
    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502051796" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="/gongan.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 11010502051796号</p></a>
</div><a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2026002434号-2</a> </span>`, '关于我们', '商务咨询', '技术咨询']
    // <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502048575" target="_blank">All Rights Reserved 11010502048575</a>
    //  <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502048575" target="_blank">京公安网备11010502048575</a>
}

export const home = {
    EN: {
        first: {
            title: '<span class="word-aiot">AIoT</span> physical<br> space <br>application platform',
            text:  `The AIoT physical space application platform provides support for intelligent management of a wide range of scenarios. Based on the city's 3D data as the base map , it uses cutting-edge technologies such as the Internet of Things, artificial intelligence, and cloud computing to build a spatial visualization management platform that integrates supervision, analysis, and early warning. `,
            tips: 'MORE'
        },
        second: {
            title:'Platform architecture',
            tips: ['SaaS scene', 'Defense cloud', 'Map update system', 'City base map']
        },
        third: {
            title:'3D city base map',
            text: 'The high-frequency collection and update of the three-dimensional real-world map of the city guarantees the authenticity and reliability of the AIoT base.Through organic integration with city resources, surveillance video, and various sensor data, it truly realizes efficient supervision and disposal of public opinion and risks.',
            tips: ['City-level modeling', 'Small update', 'Update time' , 'Update area']
        },
        forth: {
            title: 'Defense Cloud',
            tips: [
                {
                    title: 'Supercomputing platform',
                    content: ['Incremental expansion', 'Automated modeling', 'Distributed computing', 'AI image algorithm']
                },
                {
                    title: 'AI analysis',
                    content: ['Perception data processing', 'Status monitoring', 'Risk warning','Intelligent identification of differences']
                },
                {
                    title: 'Data distribution',
                    content: ['Map data update', 'Cloud-cloud docking', 'Gateway docking', 'Multi-platform sharing']
                }
            ]
        },
        fifth: {
            title: 'Easy access to IoT devices',
            text: 'The platform integrates a full set of IoT interconnection and intercommunication protocol stacks , supports multiple access solutions, and easily accesses a large number of urban IoT devices .',
            icons: {
                pc: ['MQTT', 'mbed TLS', 'mbed TLS', 'LwM2M', 'CoAP', 'mbed TLS', 'MQTT', 'LwM2M', 'CoAP', 'LWIP', 'MQTT', 'LwM2M'],
                mobile: ['MQTT', 'CoAP', 'mbed TLS', 'LwM2M']
            },
            labels: {
                pc: [null, 'Good atmosphere<br>PM2.5: 26', null, 'C<sub>3</sub>H<sub>8</sub> content: 0.3%<br>CH<sub>4</sub> content: 0.1%', 'Abnormal condition: none<br>Map update progress: 12%', 'Abnormal condition: none<br>Number of people passed: 210', null, 'C<sub>3</sub>H<sub>8</sub> content：0.3%<br>CH<sub>4</sub> content: 0.1%', 'Abnormal condition: none<br>Map update progress: 12%', null, null, 'C<sub>3</sub>H<sub>8</sub> content: 0.3%<br>CH<sub>4</sub> content: 0.1%'],
                mobile: [  'C<sub>3</sub>H<sub>8</sub> content: 0.3%<br>CH<sub>4</sub> content: 0.1%', 'Good atmosphere<br>PM2.5: 26','Abnormal condition: none<br>Map update progress: 12%','Abnormal condition: none<br>Number of people passed: 210']
            }
        },
        sixth: {
            title: 'Application scenarios',
            tips: [ 
                {
                    title: 'Smart City Industry',                    
                    text: 'Realize the fidelity restoration of stations, equipment, and environment through massive Internet of Things equipment and fine GIS and BIM information, and combine industrial and commercial operation information to realize the control of the entire life cycle of the industrial industry. ',
                    img: {
                        pc: [ require('@/assets/image/home/gongye.jpg'), require('@/assets/image/home/gongye-1.jpg') ],
                        mobile: [require('@/assets/image/home/mobile/gongye.jpg'),require('@/assets/image/home/mobile/gongye-1.jpg')]
                    }
                },
                {
                    title: 'Smart transportation',                    
                    text: 'Comprehensive urban big data can make accurate operation analysis, passenger outflow analysis, bus route optimization analysis, traffic condition analysis, comprehensive transportation analysis to assist in making scientific decisions and achieve comprehensive control and overall planning of urban transportation.',
                    img:{
                        pc: [ require('@/assets/image/home/jiaotong.jpg'), require('@/assets/image/home/jiaotong-1.jpg') ],
                        mobile: [require('@/assets/image/home/mobile/jiaotong.jpg'),require('@/assets/image/home/mobile/jiaotong-1.jpg')]
                    }
                },
                {
                    title: 'Smart travel',
                    text: 'Through in-depth analysis of traffic bayonet data and analysis of the trajectory of people traveling by car, precision marketing is effectively promoted.Through the deployment of Internet of Things equipment and meteorological data analysis in the scenic area, we can effectively reduce the vicious accidents. ',
                    img: {
                        pc: [ require('@/assets/image/home/lvyou.jpg'), require('@/assets/image/home/lvyou-1.jpg') ],
                        mobile: [require('@/assets/image/home/mobile/lvyou.jpg'),require('@/assets/image/home/mobile/lvyou-1.jpg')]
                    }
                },
                {
                    title: 'Digital planning and construction',                    
                    text: `By optimizing the spatial layout of the city's precise digital twins, effectively allocating land resources, and improving the government's space control and governance capabilities, it can achieve full-cycle growth records, full-time and space data integration, and full-factor rules. `,
                    img: {
                        pc: [ require('@/assets/image/home/guihua.jpg'), require('@/assets/image/home/guihua-1.jpg'), require('@/assets/image/home/guihua-2.jpg') ],
                        mobile: [require('@/assets/image/home/mobile/guihua.jpg'),require('@/assets/image/home/mobile/guihua-1.jpg'),require('@/assets/image/home/mobile/guihua-2.jpg')]
                    }
                },
                {
                    title: 'Smart city governance',                    
                    text: 'Use high-precision cities as the carrier to realize the visualization and interactive management of multi-dimensional government data, analyzing data from multiple perspectives and multiple levels to show a digital city with detailed data. In this way, it assists the government management department to make scientific decision-making, so as to use data intelligence to promote the fine management of the city. ',
                    img: {
                        pc: [ require('@/assets/image/home/zhili.jpg'), require('@/assets/image/home/zhili-1.jpg') ],
                        mobile: [require('@/assets/image/home/mobile/zhili.jpg'),require('@/assets/image/home/mobile/zhili-1.jpg')]
                    }
                }
            ]
        }
    },
    CN: {
        first: {
            title: '<span class="word-aiot">AIoT</span>物理<br>空间应用平台',
            text:  'AIoT物理空间应用平台为大范围场景的智慧管理提供支撑。 <br>它以城市三维数据为底图，运用物联网、人工智能、云计算等前沿技术，<br> 构建集监督、分析、预警于一体的空间可视化管理平台。',
            tips: '查看更多'
        },
        second: {
            title:'平台架构',
            tips: ['SaaS场景', '防务云', '地图更新系统', '城市底座']
        },
        third: {
            title:'三维城市底座',
            text: '高频次采集更新的城市级三维实景，保障AIoT底座的真实性与可靠性，通过与城市资源、监控视频，以及各类传感器数据的有机融合，真正实现对舆情、风险的高效监管与处置。',
            tips: ['城市级建模', '小范围更新',  '更新时间', '更新面积']
        },
        forth: {
            title: '防务云',
            tips: [
                {
                    title: '超算平台',
                    content: ['可增量拓展', '自动化建模', '分布式计算', 'AI图像算法']
                },
                {
                    title: 'AI分析',
                    content: ['感知数据处理', '状态监控', '差异智能识别', '风险预警']
                },
                {
                    title: '数据分发',
                    content: ['地图数据更新', '云云对接', '网关对接', '多平台分享']
                }
            ]
        },
        fifth: {
            title: '物联设备便捷接入',
            text: '平台集成了全套IoT互联互通协议栈，支持多种接入方案，轻松接入城市海量物联设备。',
            icons: {
                pc: ['MQTT', 'mbed TLS', 'mbed TLS', 'LwM2M', 'CoAP', 'mbed TLS', 'MQTT', 'LwM2M', 'CoAP', 'LWIP', 'MQTT', 'LwM2M'],
                mobile: ['MQTT', 'CoAP', 'mbed TLS', 'LwM2M']
            },
            labels: {
                pc: [null, '大气环境良好<br>PM2.5：26', null, 'C<sub>3</sub>H<sub>8</sub>含量：0.3%<br>CH<sub>4</sub>含量：0.1%', '异常状况：无<br>地图更新进度：12%', '异常状况：无<br>已通过人数：210人', null, 'C<sub>3</sub>H<sub>8</sub>含量：0.3%<br>CH<sub>4</sub>含量：0.1%', '异常状况：无<br>地图更新进度：12%', null, null, 'C<sub>3</sub>H<sub>8</sub>含量：0.3%<br>CH<sub>4</sub>含量：0.1%'],
                mobile: [ 'C<sub>3</sub>H<sub>8</sub>含量：0.3%<br>CH<sub>4</sub>含量：0.1%',  '大气环境良好<br>PM2.5：26','异常状况：无<br>地图更新进度：12%','异常状况：无<br>已通过人数：210人']
            }
        },
        sixth: {
            title: '应用场景',
            tips: [ 
                {
                    title: '智慧城市工业',
                    img: {
                        pc: [require('@/assets/image/home/gongye.jpg'),require('@/assets/image/home/gongye-1.jpg')],
                        mobile: [require('@/assets/image/home/mobile/gongye.jpg'),require('@/assets/image/home/mobile/gongye-1.jpg')]
                    },
                    text: '通过海量的物联网设备及结合精细的GIS、BIM信息实现对场站、设备、环境的保真还原，结合工商运营信息，实现对工业产业的全生命周期的管控。'
                },
                {
                    title: '智慧交通运输',
                    img:{
                        pc: [require('@/assets/image/home/jiaotong.jpg'),require('@/assets/image/home/jiaotong-1.jpg')],
                        mobile: [require('@/assets/image/home/mobile/jiaotong.jpg'),require('@/assets/image/home/mobile/jiaotong-1.jpg')]
                    },
                    text: '综合城市大数据作出精准运行分析、客流出行分析、公交线路优化分析、交通状况分析、交通运输综合分析，辅助作出科学决策，做到城市交通运输的全面掌握与统筹。'
                },
                {
                    title: '智慧旅游出行',
                    img: {
                        pc: [require('@/assets/image/home/lvyou.jpg'),require('@/assets/image/home/lvyou-1.jpg')],
                        mobile: [require('@/assets/image/home/mobile/lvyou.jpg'),require('@/assets/image/home/mobile/lvyou-1.jpg')]
                    },
                    text: '通过对交通卡口数据的深度分析挖掘，对自驾游出行人群的轨迹进行分析，有效促进精准营销。透过景区部署物联网设备及气象数据，有效减少恶性事故。'
                },
                {
                    title: '数字规划建设',
                    img: {
                        pc: [require('@/assets/image/home/guihua.jpg'),require('@/assets/image/home/guihua-1.jpg'),require('@/assets/image/home/guihua-2.jpg')],
                        mobile: [require('@/assets/image/home/mobile/guihua.jpg'),require('@/assets/image/home/mobile/guihua-1.jpg'),require('@/assets/image/home/mobile/guihua-2.jpg')]
                    },
                    text: '通过对城市精准的数字孪生实现优化空间布局、有效配置土地资源、提高政府空间管控水平和治理能力，实现全周期生长记录、全时空数据融合和全要素规则贯通。'
                },
                {
                    title: '智慧城市治理',
                    img: {
                        pc: [require('@/assets/image/home/zhili.jpg'),require('@/assets/image/home/zhili-1.jpg')],
                        mobile: [require('@/assets/image/home/mobile/zhili.jpg'),require('@/assets/image/home/mobile/zhili-1.jpg')]
                    },
                    text: '以高精度城市为载体，实现多维度的政务数据的可视化与交互管理，从多视角、多层次剖析数据，展现出一个数据详实的数字城市，辅助政府管理部门进行科学的决策，做到用数据智能推进城市精细化管理。'
                }
            ]
        }
    }
}

// export const about = {
//     EN: {
//         first: {
//             title: [require('@/assets/image/about/title-en-l.svg'), require('@/assets/image/about/title-en-min.svg'),require('@/assets/image/about/title-en-m.svg')]
//         },
//         second: {
//             title: 'About us',
//             text: 'Airlook Defence System (Nanjing) Co., Ltd. is a wholly-owned subsidiary of AIRLOOK, <br>a high-precision map service provider. The core positioning is to build a “city-level AIoT physical space application platform”. The company relies on the powerful spatial networking system and mapping technology to digitally simulate the real physical space. At the same time, combined with the access of diversified Internet of Things data, an urban digital twin system that can be perceived in real time and can insight into trends has been created, driving the penetration and application of intelligent space management concepts in government management and various industry-level scenarios.'
//         },
//         third: {
//             title: 'Contact us',
//             contact: [
//                 {
//                     id: 'tel',
//                     title: 'Phone number',
//                     text: '400-718-0909'
//                 },
//                 {
//                     id: 'bd',
//                     title: 'Business consulting',
//                     text: 'zhangnan@airlook.com'
//                 },
//                 {
//                     id: 'tech',
//                     title: 'Technical consulting',
//                     text: 'bianbosen@airlook.com'
//                 },
                
//                 {
//                     id: 'contact',
//                     title: 'Company address',
//                     text: '15 / F, North AVIC Technology Building, 58 Beiyuan Road, Chaoyang District, Beijing, China'
//                 }
//             ]
//         }
//     },
//     CN: {
//         first: {
//             title: [require('@/assets/image/about/title-l.svg'), require('@/assets/image/about/title-min.svg'),require('@/assets/image/about/title-m.svg')]
//         },
//         second: {
//             title: '关于我们',
//             text: '埃洛克防务系统（南京）有限公司为高精度地图服务商AIRLOOK的全资子公司，<br>核心定位于打造“城市级AIoT物理空间应用平台”。公司依托强大的空间组网体系与成图技术对现实物理空间数字化仿真，同时结合多元化物联网数据的接入，创建了一个可实时感知、可洞悉趋势的城市数字孪生系统，驱动智能化的空间管控理念在政府管理以及各类行业级场景中渗透和应用。'
//         },
//         third: {
//             title: '联系我们',
//             contact: [
//                 {
//                     id: 'tel',
//                     title: '联系电话',
//                     text: '400-718-0909'
//                 },
//                 {
//                     id: 'bd',
//                     title: '商务咨询',
//                     text: 'zhangnan@airlook.com'
//                 },
//                 {
//                     id: 'tech',
//                     title: '技术咨询',
//                     text: 'bianbosen@airlook.com'
//                 },                
//                 {
//                     id: 'contact',
//                     title: '公司地址',
//                     text: '北京市朝阳区北苑路58号航空科技大厦北15层'
//                 }
//             ]
//         }        
//     }
// }

export const about = {
  EN: {
      first: {
          title: [require('@/assets/image/about/title-en-l.svg'), require('@/assets/image/about/title-en-min.svg'),require('@/assets/image/about/title-en-m.svg')]
      },
      second: {
          title: 'About us',
          text: 'Airlook Defence System (Nanjing) Co., Ltd. is a wholly-owned subsidiary of AIRLOOK, <br>a high-precision map service provider. The core positioning is to build a “city-level AIoT physical space application platform”. The company relies on the powerful spatial networking system and mapping technology to digitally simulate the real physical space. At the same time, combined with the access of diversified Internet of Things data, an urban digital twin system that can be perceived in real time and can insight into trends has been created, driving the penetration and application of intelligent space management concepts in government management and various industry-level scenarios.'
      },
      third: {
        title: 'Contact us',
        contact: [
            {
                id: 'tel',
                title: 'Phone number',
                address: '400-718-0909'
            },
            {
                id: 'bd',
                title: 'Business consulting',
                address: 'PaaS@airlook.com'
            },
            {
                id: 'tech',
                title: 'Technical consulting',
                address: 'Tech@airlook.com'
            },
            
            {
                id: 'contact',
                title: 'Company address',
                address: '15 / F, North AVIC Technology Building, 58 Beiyuan Road, Chaoyang District, Beijing, China'
            }
        ]
      }

  },
  CN: {
      first: {
          title: [require('@/assets/image/about/title-l.svg'), require('@/assets/image/about/title-min.svg'),require('@/assets/image/about/title-m.svg')]
      },
      second: {
          title: '关于我们',
        //   text: '埃洛克防务系统（南京）有限公司为元宇宙地图服务商AIRLOOK的全资子公司，<br>核心定位于打造“城市级AIoT物理空间应用平台”。公司依托强大的空间组网体系与成图技术对现实物理空间数字化仿真，同时结合多元化物联网数据的接入，创建了一个可实时感知、可洞悉趋势的城市数字孪生系统，驱动智能化的空间管控理念在政府管理以及各类行业级场景中渗透和应用。'
        text: '埃洛克航空是中国领先的低空基础设施解决方案提供商，2015年由航天、中科院及互联网领域顶尖团队创立，具备国家级军转民技术背景。公司深度参与多项无人机领域“国家重点研发计划”，拥有近百项核心专利，并作为民航局低空地理信息与航路重点实验室建设单位，奠定行业基石。依托自主可控的无人机控制系统、空间AI决策系统、及高性能引擎平台，埃洛克航空为智慧城市、应急管理、生态保护、文旅创新等领域提供空间智能解决方案，致力于构建低空服务网络基础设施。'
      },
      third: {
          title: '联系我们',
          contact: [
              {
                  id: 'beijing',
                  tel:'商务咨询：400-718-0909',
                  email:'商务咨询：PaaS@airlook.com',
                  email_tech:'技术咨询：Tech@airlook.com',
                  title: '埃洛克航空科技（北京）有限公司',
                  address:'北京市朝阳区望京街9号万科时代中心'
              },
            //   {
            //     id: 'nanjing',
            //     title: '埃洛克防务（南京）有限公司',
            //     address:'南京市浦口区江浦街道科创广场6号楼101室',
            //     name:'张春雷',
            //     tel:'186-1283-4364',
            //     email:'zhangchunlei@airlook.com'
            //   },
            //   {
            //     id: 'shandong',
            //     title: '埃洛克科技（山东）有限公司',
            //     address:'青岛市崂山区香港东路中泰证券大厦11层',
            //     name:'卢威良',
            //     tel:'155-8888-2048',
            //     email:'luweiliang@airlook.com'
            //   },              
            //   {
            //     id: 'guizhou',
            //     title: '贵州埃洛克科技有限公司',
            //     address:'贵阳市花溪大道中创联合大厦13-F',
            //     name:'王雪',
            //     tel:'159-1028-1003',
            //     email:'wangxue@airlook.com'
            //   }
          ]
      }        
  }
}

export const observer = {
    EN: {
        first: {
            title: 'Scout system - Observer',
            text: 'The Observer is an integrated scouting drone system on main use of swift detecting and restoring of unknown terrains. It supports night vision which clearly reflects real-time dynamic situations in the dark.  With its powerful mapping and cloud sharing capabilities, the Observer supports synchronous viewing in real time from multiple sites. It is portable for carrying, and is widely used on Police patrolling, emergency rescue and outdoor explorations.'
        },
        second: [
            {
                title: 'Emergency rescues',
                text: 'The on-site  environment of natural disasters and unexpected accident is often complicated, and it’s hard to guarantee the personal safety of those rescue personnel . Using the Observer to conduct on-site reconnaissance can make pre-judge of the disaster scene through the synchronous image transmission. With its rapid mapping function for high-resolution images , the first on-site picture can be obtained and sent to the command center which assists the decision-making and facilitates high-efficiency accurate rescues so as to reduce unnecessary losses.'
            },
            {
                title: 'Military detection',
                text: 'With its advantage of flexibility and concealment, the Observer is able to catch pictures where satellites and helicopters cannot reach. Its widely used for  intelligence collecting ,target enemy tracking, which greatly facilitates  military detection.'
            },
            {
                title: 'Outdoor expeditions',
                text: 'The Observer is broadly used in the event of outdoor expedition due to its easy-carrying characteristics. Under  variable and complex situations, it helps people to get the unknown topography applied with the synchronous mapping and transmission function for high-resolution images, and helps with path planning.'
            },
            {
                title: 'Policing',
                text: 'With its flexible maneuverability of easy-carrying and all-round perspective, the Observer is favorable not only on evidence investigation, but also on crowd diversion, in order to release the police manpower.'
            }
        ],
        third: {
            title: 'Automatic avoid-obstacle',
            text: 'The system incorporates the forward-looking, downward-looking and upward-looking sensors of the aircraft.It can automatically sense and avoid obstacles, achieve accurate hovering, and can fly safely in complex scenes.'
        },
        forth: {
            title: 'One-click sharing',
            text: 'Millisecond delay; Smooth stability; High-accessible dual vision synchronous live streaming;  One-click sharing service of result images;  Keep working on transmission with weak web service; Make it real for simultaneous watching of the on-site conditions from command centers.',
            tips: ['QR code sharing', 'URL sharing']
        },
        fifth: {
            title: 'Swift modeling',
            text: 'On the basis of synchronous positioning, mapping construction and orthophoto rectify algorithm,  the Observer is capable of synchronously generating  two-dimensional orthophotos during the flight, so as to achieve swift modeling in seconds.',
            tips: 'Swift modeling in seconds'
        },
        sixth: {
            title: 'Three-dimensional reconstruction',
            text: 'With its Self-developed modeling algorithm and multi-machine distributed processing mode, the Observer is supporting cloud modeling and private installation. It is very simple to handle, with only one click for modeling.'
        },
        // 后补
        seventh: {
            title: 'Expanded AI function',
            text: 'Extended AI functions:  the Observer system supports designed extended functions like AI identification and business operations. Based on deep learning algorithm and neural network technology, the Observer can realize autonomous learning of targeted data, and integrate AI image recognition and analysis function.  Comparing the differences of diverse images, it can dynamically identify humans and cars in video pictures, fly around static objects, and follow up moving objects.'
        },
        eighth: {
            title: 'Simulated system',
            text: 'By using our core 3D restoring technology, the simulated system would make you, as if be personally on the scene, to operate the drone, just like playing games. You could easily learn piloting skills indoors of taking off, landing, hovering , planing routes, etc.'
        },
        ninth: {
            title: 'More features',
            tips: [['emergency mechanism', 'measuring temperature', 'synchronization of multi-terminal marks', 'mapping'], ['HD offline Maps', 'large storage capacity', 'search for people / fires', 'airspace application service']]
        },
        params:[
            {
                img: require('@/assets/image/observer/observer.png'),
                width: 136,
                title: 'Groud-control station',
                detail: [
                    ['Size', '420x326x182mm'],
                    ['Weight', '8.5KG'],
                    ['Material', 'ABS + Carbon fiber'],
                    ['Temperature tolerance', '-30℃ to 50℃'],
                    ['Resolution', '13.3\' 1920×1080;<br/> 10.1\' 1280×800'],
                    ['Effective storage', '8GB'],
                    ['Storage capacity', '2304GB SSD'],
                    ['External charging port', '1'],
                    ['USB interface', '3'],
                    ['Flight duration', '120 minutes'],
                    ['Communication', '2.4/5.8GHz'],
                    ['Max effective transmission distance', '8KM'],
                ]
            },{
                img: require('@/assets/image/observer/airplane.png'),
                title: 'Aircraft',
                width: 136,
                detail: [
                    ['Dimensions', 'Unfolded, propellers excluded,<br>810×670×430mm (L×W×H)'],
                    ['Weight', '6.3kg（with two TB60 batteries）'],
                    ['Max payload', '2.7kg'],
                    ['Max flight time', '55min'],
                    ['Service ceiling above sea level', '7000m (with 2195 propellers)'],
                    ['Max takeoff weight', '9kg'],
                    ['Max ascent  speed', '5m/s'],
                    ['Max descend speed (vertical)', '3m/s'],                    
                    ['Max wind resistance', '15m/s'],
                    ['Ingress protection rating', 'IP45'],
                    ['Operating temperature', '-20° to 50° C']
                ]
            },
            {
                img:  require('@/assets/image/observer/Z30.png'),
                title: 'Payload Z30',
                width: 136,
                detail: [
                    ['Size', '152×137×61mm'], 
                    ['Weight', '556g'],
                    ['Digital zoom', '6 times'],                        
                    ['Operating temperature', '-10℃ to 45℃'],
                    ['Sensor', '1/2.8"CMOS <br>Effective pixels: 2.13 million'],
                    ['Camera lens', '30x optical zoom <br>F=4.3mm – 129mm F1.6 – F4.7'],
                    ['Electronic shutter speed', '1/30 – 1/6000 s'],

                ]
            },
            {
                img:  require('@/assets/image/observer/H20.png'),
                title: 'Payload H20T',
                width: 85,
                grid: [5, 11, 17, 25, 30],
                detail: [
                    ['Dimensions', '167×135×161mm'], 
                    ['Weight', '828±5g'],
                    ['IngressProtection rating', 'IP44'],                        
                    ['Operating temperature', '-20℃ to 50℃'],
                    ['Storage temperature', '-20℃ to 50℃'],
                    ['Zoom camera', null],
                    ['Sensor', '1/1.7" CMOS, 20 MP'],
                    ['Electronic shutter speed', '1 ~ 1/8000s'],
                    ['Video resolution', '3840x2160@30fps, <br>1920x1080@30fps'],
                    ['Photo size', '5184 × 3888'],
                    ['Lens', 'DFOV: 66.6°-4° <br>Focal length: 6.83-119.94mm <br>(equivalent: 31.7-556.2 mm)<br>Aperture: f/2.8-f/11(normal), <br>f/1.6-f/11(night scene)<br>Focus: 1m to ∞(wide), <br>8m to ∞ (telephoto)'],
                    ['Wide camera', null],
                    ['Sensor', '1/2.3" CMOS, 12MP'],
                    ['Lens', 'DFOV：82.9°<br>Focal length: 4.5mm<br>(equivalent: 24 mm)<br>Aperture: f/2.8<br>Focus: 1m to ∞'],
                    ['Shutter speed', '1 ~ 1/8000'],
                    ['Video resolution', '1920×1080@30fps'],
                    ['Photo size', '4056×3040'],
                    ['Thermal camera', null],
                    ['Sensor', 'Uncooled VOx microbolometer'],
                    ['Lens', 'DFOV: 40.6°<br>Focal length: 13.5mm,<br>(equivalent: 58mm<br>Aperture： f/1.0<br>Focus: 5m to ∞'],
                    ['Digital zoom', '1x，2x，4x，8x'],
                    ['Video resolution', '640×512 @30Hz'],
                    ['Image resolution', '640×512'],
                    ['Pixel pitch', '12μm'],
                    ['Spectral band', '8-14μm'],
                    ['Laser rangefinder', null],
                    ['Wave length', '905nm'],
                    ['Measurement range', '3-1200m(to a vertical surface with ≥12m <br>diameter and 20% reflection rate)'],
                    ['Measurement accuracy', '±(0.2m+D×0.15%)']
                ]
            },
        ]
    },
    CN: {
        first: {
            title: '侦查系统-观测者',
            text: '观测者是一套综合无人机飞行侦查系统，主要用于对未知地形地貌快速侦查还原，支持夜视功能，夜间实时动态清晰展现，强大的成图与云端分享能力，支持多端实时同步查看，轻巧易用便于携带。广泛应用于公安巡查、应急搜救及户外探险等场景。'
        },
        second: [
            {
                title: '应急搜救',
                text: '由于自然灾害及突发事故现场的环境复杂多变，搜救人员的人身安全难以保障。使用观测者进行现场侦察，通过实时图传的影像来对灾害现场做预判；通过高分辨的快速成图功能，获取现场第一张图发送到指挥中心，辅助指挥部门的决策，利于更高效准确地展开施救任务，减少不必要的损失。'
            },
            {
                title: '军事侦查',
                text: '在军事侦查中，观测者以其机动灵活，不易被发现的特性，可以填补卫星和侦察机达不到的盲区，用于收集情报，追踪敌方目标，为军事侦查提供方便。'
            },
            {
                title: '户外探险',
                text: '观测者以其轻巧便携的特性，广泛应用于户外探险中，应对复杂多变的环境，通过高分辨率实时视频画面了解未知地形地貌，通过高分辨率的快速成图功能，掌握前方地图，完成路径规划等操作。'
            },
            {
                title: '公安巡检',
                text: '观测者以其便于携带，全方位视角与机动灵活的特性，既能调查取证、又能疏散引导来辅助执法，提升效率释放警力。'
            }
        ],
        third: {
            title: '自动避障',
            text: '系统结合飞行器前视、下视、上视传感器，可自动感知并躲避障碍物，实现精准悬停，在复杂场景下也可安心飞行。'
        },
        forth: {
            title: '一键分享',
            text: '提供毫秒级延迟、稳定流畅、高可用的双光实时直播流，成果图一键分享服务，弱网下仍能正常推流，实现指挥中心和现场实时同步查看。',
            tips: ['二维码分享', '网址分享']
        },
        fifth: {
            title: '秒级成图',
            text: '基于同步定位、地图构建和影像正射纠正算法，在飞行过程中实时生成二维正射影像，实现边飞边出图，达到秒级成图的效果。',
            tips: '边飞边出图，秒级效果'
        },
        sixth: {
            title: '三维重建',
            text: '自研建模算法，多机分布式处理，支持云端建模和私有化部署，操作简单，一键成模。'
        },
        // 后补
        seventh: {
            title: '扩展AI功能',
            text: '支持定制AI识别、业务操作等拓展功能。基于深度学习算法和神经网络技术，完成目标数据自主学习，集成图像AI识别分析功能，对图像进行差异对比，能动态识别视频画面中的人跟车，绕静态目标物飞行、对动态目标物进行跟踪。'
        },
        // 后补
        eighth: {
            title: '仿真系统',
            text: '使用三维还原技术，像打游戏一样，让你身临其境体验无人机操作，足不出户便可轻松学习起飞、降落、悬停、航线飞行等飞行技能。'
        },
        ninth: {
            title: '更多小功能',
            tips: [['应急机制', '测温', '标注多端同步', '测量'], ['高清离线地图', '海量存储空间', '搜人/搜火', '空域申请服务']]
        },
        params:[
            {
                img: require('@/assets/image/observer/observer.png'),
                width: 136,
                title: '地面操控站',
                detail: [
                    ['尺寸', '420x326x182mm'],
                    ['重量', '8.5KG'],
                    ['材质', 'ABS+碳纤维'],
                    ['耐受温度范围', '-30℃至50℃'],
                    ['分辨率', '13.3\' 1920×1080;<br/> 10.1\' 1280×800'],
                    ['运行内存', '8GB'],
                    ['存储容量', '2304GB SSD'],
                    ['外接充电口', '1个'],
                    ['USB接口', '3个'],
                    ['续航时间', '120分钟'],
                    ['通信频率', '2.4/5.8GHz'],
                    ['最大信号有效距离', '8KM'],
                ]
            },{
                img: require('@/assets/image/observer/airplane.png'),
                title: '无人机',
                width: 136,
                detail: [
                    ['尺寸（展开）', '810×670×430mm<br>（展开，不包含桨叶）'],
                    ['重量', '6.3kg 空机重量（含双电池）'],
                    ['最大载重', '2.7kg'],
                    ['最大起飞重量', '9kg'],
                    ['最大上升速度', '5m/s'],
                    ['最大下降速度(垂直)', '3m/s'],
                    ['最大飞行时长', '55min'],
                    ['最大起飞海拔高度', '7000m（高原桨）'],
                    ['最大可承受风速', '15m/s（7级风）'],
                    ['IP防护等级', 'IP45'],
                    ['工作环境温度', '-20° 至 50° C']
                ]
            },
            {
                img:  require('@/assets/image/observer/Z30.png'),
                title: '载荷 Z30',
                width: 136,
                detail: [
                    ['尺寸', '152×137×61mm'], 
                    ['重量', '556g'],
                    ['数字变焦', '6倍'],                        
                    ['工作温度', '-10℃至45℃'],
                    ['传感器', '1/2.8"CMOS 有效像素：213万'],
                    ['镜头', '30倍光学变焦镜头 F=4.3mm–129mm<br data-hidden=true>F1.6 – F4.7'],
                    ['电子快门速度', '1/30 – 1/6000秒'],

                ]
            },
            {
                img:  require('@/assets/image/observer/H20.png'),
                title: '载荷 H20T',
                width: 85,
                grid: [5, 11, 17, 25, 30],
                detail: [
                    ['尺寸（展开）', '167×135×161mm'], 
                    ['重量', '828±5g'],
                    ['防水等级', 'IP44'],                        
                    ['工作温度', '-20℃ 至 50℃'],
                    ['存储温度', '-20℃ 至 50℃'],
                    ['变焦相机参数', null],
                    ['传感器', '1/1.7" CMOS，有效像素2000万'],
                    ['电子快门速度', '1 ~ 1/8000s'],
                    ['视频分辨率', '3840x2160@30fps，<br>1920x1080@30fps'],
                    ['最大照片尺寸', '5184 × 3888'],
                    ['镜头', 'DFOV：66.6°-4° <br>焦距：6.83-119.94mm（等效焦距：<br>31.7-556.2 mm）<br>光圈：f/2.8-f/11（正常），<br>f/1.6-f/11（夜景）<br>对焦距离：1m 至无穷远（广角），<br>8m至无穷远（长焦）'],
                    ['广角相机参数', null],
                    ['传感器', '1/2.3" CMOS，有效像素1200万'],
                    ['镜头', 'DFOV：82.9°<br>焦距：4.5mm（等效焦距：24 mm）<br>光圈：f/2.8<br>对焦距离：1m至无穷远'],
                    ['快门速度', '1 ~ 1/8000'],
                    ['视频分辨率', '1920×1080@30fps'],
                    ['最大照片尺寸', '4056×3040'],
                    ['热成像相机', null],
                    ['热成像传感器类型', '非制冷氧化钒（VOx）<br>微测热辐射计'],
                    ['镜头', 'DFOV：40.6°<br>焦距：13.5mm（等效焦距：58mm）<br>光圈：f/1.0<br>对焦距离：5m至无穷远'],
                    ['数字变焦', '1x，2x，4x，8x'],
                    ['视频分辨率', '640×512 @30Hz'],
                    ['照片分辨率', '640×512'],
                    ['像元间距', '12μm'],
                    ['波长范围', '8-14μm'],
                    ['激光测距仪', null],
                    ['波长', '905nm'],
                    ['测量范围', '3-1200m（直径12m、20%<br>反射率的垂直反射面）'],
                    ['测量精度', '±(0.2m+D×0.15%)']
                ]
            },
        ]
    }
}

export const catcher = {
    EN: {
        first: {
            title: 'Fixed-routine patrol - Catcher',
            text: 'The Catcher is mainly used for large-scale fixed-sites images collection with high-frequency.  One-time setting and automatically running. Intelligentized analysis from cloud SaaS system, it greatly improves the analytical efficiency, so that is popular with power grid inspection, governing on river bed silt, and exploration of certain scenes. '
        },
        second: [
            {
                title: ['Power line <br>inspection', 'Power line inspection'],
                text: 'Automatic acquisition of fine images in power grid inspection, the Catcher is able to improve not only the catching frequency, but also data qualities,  releasing the manpower and cost pressure of enterprises , so as to upgrade the efficiency and accuracy of power grid inspection.'
            },
            {
                title: 'Pipeline inspection',
                text: 'Automatic high-efficient inspecting and patrolling of pipeline security and monitoring nearby surroundings; whole process without manual manipulation; finding and reporting accidents in first time.'
            },
            {
                title: 'Highway patrol',
                text: 'With its  all-round perspectives and flexible maneuverability, the Catcher helps not only on investigation and evidence collection, but also on guiding evacuation which assists law enforcement. That greatly improves policing efficiency and releases manpower. also helps monitoring road maintenance and detection.'
            },
            {
                title: 'Waterway patrolling and inspection',
                text: 'With timeliness and high maneuverability,  the Catcher applied in waterway patrolling and inspection helps with time and labor cost saving, automatically patrolling & inspecting; remote photographing & evidence collecting, tracking and investigating; solving problems like littering and illegally effluents unloading which are difficult to deal with by manual patrolling.'
            },
        ],
        third: {
            title: 'Freely switch between manual and automatic mode',
            text: 'To achieve the whole "unmanned" operating mode，deploy automatic landing pads and drones in the mission area, set the fixed working hours of the drones through the cloud, the drones can be fully automatic takeoff and landing, automatic charging, automatic and continuous execution of inspection tasks on time, and storage of inspection images and video information.It can also provide one-click switching from automatic mode to manual control mode, which can easily control the drone flight manually and perform cruise tasks in a refined manner.'
        },
        forth: {
            title: 'Replacing batteries independently with the intelligent mechanical arm',
            text: 'The built-in intelligent mechanical arm in the automatic landing pads can automatically complete the replacement of the drone battery and automatically charge the replaced battery to ensure that the drone can carry out high-frequency and intensive inspection tasks.'
        },
        fifth: {
            title: 'Embedded 3D high-precision map',
            text: 'Collecting and making high-precision three-dimensional maps for the inspection task area in advance. Remotely controlling the drone flight, let you feel the immersive operation experience. According to the demand, seamlessly integrate real-time camera images in urban streets to achieve panoramic, real-time, multi-angle 24-hour monitoring of the overall scene.'
        },
        sixth: {
            title: 'Expanding AI functions',
            text: `It can deeply customize AI functions, fully penetrate the industry's business processes, and create a stronger and more intelligent fixed-point cruise system.`,
            tips: ['Multi-element identification and customization', 'Intelligent identification of abnormal nodes', 'Modeling and forecasting trends and laws', '3D mapping service', 'Professional evaluation and analysis report']
        },
        seventh: {
            title: 'Networking extension, SaaS for industries',
            text: ' For the long-distance inspections like  power grids, oil pipelines, waterways,and highways, it often extends networking service between hangars to increase flying distance and duration, in order to achieve long-range automatic flight and inspection.To provide professional SaaS management systems, including task management, route management, real-time monitoring, patrolling  data management and so on.'
        },
        eighth: {
            title: 'Remote control from cloud service',
            text: 'Real-time monitoring and operation from remote control; It is settable of fixed-time remote start-up for the Catcher to be automatically operating and playing back the monitoring scenes.'
        },
        ninth: {
            title: 'Intelligentized analysis',
            text: 'Integrated the advanced and special core algorithms for image identification to realize dynamic identifying of targeted objects.   Checking the defects of targeted objects basing on deep-learning algorithm, to find out the defects and keep tracking, and then save the screen-shots for defective objects.'
        },
        parmas: [            
            {
                img: require('@/assets/image/watcher/p7-box.png'),
                title: 'Automatic airport',
                width: 98,
                detail: [
                    ['Size', '2200x1900x1550 mm'],
                    ['Weight', '1700KG'],
                    ['Material', 'Steel / Aluminum'],
                    ['Input voltage', '220V'],
                    ['Power consumption', '2000W (Peak value) <br>/ 500W (Average)/210W(Standby)'],
                    ['battery capacity', 'It can be expanded to 5 groups at most,<br> one of which is used for cooling/heating'],
                    ['Network conditions', 'Ethernet above 80Mbps'],
                    ['Way to install', 'Four-point anchoring on <br>cement floor'],
                    // ['Safety standard', 'GB4943'],
                    ['Protection functions', 'Undervoltage, Overload,<br>Electric leakage, Short-circuit protection'],
                    ['Operating temperature', '-20℃ to 40℃'],
                    ['Frame protection level', 'IP45'],
                    ['Classification of wind resistance', '6'],
                    ['Safety standards', 'GB4943'],
                    ['Daily duty times', '10-25'],
                    ['Non-failure operation time', '5000 hours'],
                    // ['Interval time', '3 minutes']
                ]
            },
            {
                img: require('@/assets/image/watcher/p7.png'),
                title: 'Operating desk',
                width: 140,
                detail: [
                    ['Size', '900x400x90mm (Without rocker)'],
                    ['Weight', '10KG'],
                    ['Material', 'ABS + aerometal'],
                    ['resolution', '5120×1440；1920X1080'],
                    ['storage', 'Max 32GB'],
                    ['USB interface', '3'],
                    ['Input voltage', '220V'],
                    ['Power consumption', '300W']
                ]
            },
            {
                img: require('@/assets/image/observer/airplane.png'),
                title: 'Aircraft',
                width: 136,
                detail: [
                    ['Dimensions', 'Unfolded, propellers excluded,<br>810×670×430mm (L×W×H)'],
                    ['Weight', '6.3kg（with two TB60 batteries）'],
                    ['Max payload', '2.7kg'],
                    ['Max flight time', '55min'],
                    ['Service ceiling above sea level', '7000m (with 2195 propellers)'],
                    ['Max takeoff weight', '9kg'],
                    ['Max ascent  speed', '5m/s'],
                    ['Max descend speed (vertical)', '3m/s'],                    
                    ['Max wind resistance', '15m/s'],
                    ['Ingress protection rating', 'IP45'],
                    ['Operating temperature', '-20° to 50° C']
                ]
            },
            {
                img:  require('@/assets/image/observer/H20.png'),
                title: 'Payload H20T',
                width: 85,
                grid: [5, 11, 17, 25, 30],
                detail: [
                    ['Dimensions', '167×135×161mm'], 
                    ['Weight', '828±5g'],
                    ['IngressProtection rating', 'IP44'],                        
                    ['Operating temperature', '-20℃ to 50℃'],
                    ['Storage temperature', '-20℃ to 50℃'],
                    ['Zoom camera', null],
                    ['Sensor', '1/1.7" CMOS, 20 MP'],
                    ['Electronic shutter speed', '1 ~ 1/8000s'],
                    ['Video resolution', '3840x2160@30fps, <br>1920x1080@30fps'],
                    ['Photo size', '5184 × 3888'],
                    ['Lens', 'DFOV: 66.6°-4° <br>Focal length: 6.83-119.94mm <br>(equivalent: 31.7-556.2 mm)<br>Aperture: f/2.8-f/11(normal), <br>f/1.6-f/11(night scene)<br>Focus: 1m to ∞(wide), <br>8m to ∞ (telephoto)'],
                    ['Wide camera', null],
                    ['Sensor', '1/2.3" CMOS, 12MP'],
                    ['Lens', 'DFOV：82.9°<br>Focal length: 4.5mm<br>(equivalent: 24 mm)<br>Aperture: f/2.8<br>Focus: 1m to ∞'],
                    ['Shutter speed', '1 ~ 1/8000'],
                    ['Video resolution', '1920×1080@30fps'],
                    ['Photo size', '4056×3040'],
                    ['Thermal camera', null],
                    ['Sensor', 'Uncooled VOx microbolometer'],
                    ['Lens', 'DFOV: 40.6°<br>Focal length: 13.5mm,<br>(equivalent: 58mm<br>Aperture： f/1.0<br>Focus: 5m to ∞'],
                    ['Digital zoom', '1x，2x，4x，8x'],
                    ['Video resolution', '640×512 @30Hz'],
                    ['Image resolution', '640×512'],
                    ['Pixel pitch', '12μm'],
                    ['Spectral band', '8-14μm'],
                    ['Laser rangefinder', null],
                    ['Wave length', '905nm'],
                    ['Measurement range', '3-1200m(to a vertical surface with ≥12m <br>diameter and 20% reflection rate)'],
                    ['Measurement accuracy', '±(0.2m+D×0.15%)']
                ]
            }
        ]        
    },
    CN: {
        first: {
            title: '定点巡航系统-守望者',
            text: ' 主要用于对大范围固定场所高频次采样测量，一次部署自动运行，配合云端SaaS系统的智能分析，提高对巡查范围的数据分析效率。广泛应用于线路巡检、河床淤泥治理及重点场所勘查等场景。 '
        },
        second: [
            {
                title: ['电力巡检', '电力巡检'],
                text: '无人机全自动精细化巡检在电网上的应用，既能提高数据采集频次、又能提升数据采集质量，解决企业在电力巡检上的人员、成本压力，提高电力巡检的效率和准确率。'
            },
            {
                title: '管道巡检',
                text: '全自动高频巡检、巡逻，全过程无需人工操控，对管道进行安全巡查，对周边区域进行监控，发现可疑事件及时处理。'
            },
            {
                title: '高速巡逻',
                text: '无人机以其全方位视角与机动灵活的特性，既能调查取证、又能疏散引导来辅助执法，提升效率释放警力，还能进行养护监控和检测。'
            },
            {
                title: '航道巡检巡逻',
                text: '无人机在航道巡检巡逻中的应用，具有及时性、机动性高等特点，除了节约时间和人力成本，全自动巡检巡逻，还可远程拍照取证、追踪排查、解决人工巡河过程中难以应对的乱倒垃圾、非法排污等问题。'
            },
        ],
        third: {
            title: '手自动模式自由切换',
            text: '任务区域部署自动机场和无人机，通过云端设置无人机定时工作时间，无人机可进行全自动起降，自动充电，按时全自动连续执行巡检任务，存储巡检图像和视频信息，实现全程“无人化”的作业模式。提供一键切换到手动操控模式，提供极简的操作环境，可轻松手动操控无人机飞行，精细化执行巡航任务。'
        },
        forth: {
            title: '智能机械臂，自主更换电池',
            text: '自动机场内置智能机械臂，可自动完成无人机电池更换，并将换下的电池自动充电，确保无人机能进行高频次、密集型巡检任务。'
        },
        fifth: {
            title: '内嵌三维高精度地图',
            text: '为巡检任务区域预先采集并制作高精度三维地图，远程操控无人机飞行，也能让你有身临其境的操作体验。根据需求无缝融合城市街道中的摄像头实时影像，实现对整体现场的全景、实时、多角度7X24小时监控。'
        },
        sixth: {
            title: '扩展AI功能',
            text: '可深度定制AI功能，全面渗透行业业务流程，打造更强劲、更智能化的定点巡航系统。',
            tips: ['多要素的识别定制', '异常节点智能识别', '趋势规律建模预测', '三维地图制图服务', '专业评估分析报告']
        },
        seventh: {
            title: '组网扩展，行业SaaS',
            text: '在电力、石油管道、航道、高速公路等长距离安全巡检，可通过机库之间的组网扩展，增加飞机航程和航时，完成长距离自主飞行和巡检。提供行业的SaaS管理系统，包含任务管理、线路管理、实时监控，巡检数据管理等功能。'
        },
        eighth: {
            title: '云端调度',
            text: ' 远程实时监控；远程操作，可设置定时远程启动无人机自动执行任务；回放无人监控画面。 '
        },
        ninth: {
            title: '智能分析',
            text: '整合图像识别领域先进、独特的核心算法，实现目标物的动态识别；基于深度学习算法，对目标图像缺陷进行检测，发现缺陷进行追踪，对缺陷目标截图保存。'
        },
        parmas: [            
            {
                img: require('@/assets/image/watcher/p7-box.png'),
                title: '自动机场',
                width: 98,
                detail: [
                    ['尺寸', '2200x1900x1550 mm'],
                    ['重量', '1700KG'],
                    ['材料', '钢/铝'],
                    ['输入电压', '220V'],
                    ['功耗', '2000W(峰值)/500W(平均)<br>/210W(待机)'],
                    ['电池组容量', '最大可扩展至5组<br>其中1组仓位用于冷却/加热'],
                    ['网络条件', '80Mbps以上以太网'],
                    ['安装方式', '水泥地面四点锚定'],
                    // ['安全标准', 'GB4943'],
                    ['保护', '欠压，过载，漏电，短路保护'],
                    ['工作温度', '-20℃至40℃'],
                    ['壳体防护等级', 'IP45'],
                    ['抗风等级', '6级'],
                    ['安全标准', 'GB4943'],
                    ['每日出勤频次', '10-25次'],
                    ['无故障运行时间', '5000小时'],
                    // ['作业间隔周期', '3分钟']
                ]
            },
            {
                img: require('@/assets/image/watcher/p7.png'),
                title: '操控台',
                width: 140,
                detail: [
                    ['尺寸', '900x400x90mm（不含摇杆）'],
                    ['重量', '10KG'],
                    ['材质', 'ABS+航空铝合金'],
                    ['分辨率', '5120×1440；1920X1080'],
                    ['内存', '最大支持到32GB'],
                    ['USB接口', '3个'],
                    ['输入电压', '220V'],
                    ['功耗', '300W']
                ]
            },
            {
                img: require('@/assets/image/observer/airplane.png'),
                title: '无人机',
                width: 136,
                detail: [
                    ['尺寸（展开）', '810×670×430mm<br>（展开，不包含桨叶）'],
                    ['重量', '6.3kg 空机重量（含双电池）'],
                    ['最大载重', '2.7kg'],
                    ['最大起飞重量', '9kg'],
                    ['最大上升速度', '5m/s'],
                    ['最大下降速度(垂直)', '3m/s'],
                    ['最大飞行时长', '55min'],
                    ['最大起飞海拔高度', '7000m（高原桨）'],
                    ['最大可承受风速', '15m/s（7级风）'],
                    ['IP防护等级', 'IP45'],
                    ['工作环境温度', '-20° 至 50° C']
                ]
            },
            {
                img:  require('@/assets/image/observer/H20.png'),
                title: '载荷 H20T',
                width: 85,
                grid: [5, 11, 17, 25, 30],
                detail: [
                    ['尺寸（展开）', '167×135×161mm'], 
                    ['重量', '828±5g'],
                    ['防水等级', 'IP44'],                        
                    ['工作温度', '-20℃ 至 50℃'],
                    ['存储温度', '-20℃ 至 50℃'],
                    ['变焦相机参数', null],
                    ['传感器', '1/1.7" CMOS，有效像素2000万'],
                    ['电子快门速度', '1 ~ 1/8000s'],
                    ['视频分辨率', '3840x2160@30fps，<br>1920x1080@30fps'],
                    ['最大照片尺寸', '5184 × 3888'],
                    ['镜头', 'DFOV：66.6°-4° <br>焦距：6.83-119.94mm（等效焦距：<br>31.7-556.2 mm）<br>光圈：f/2.8-f/11（正常），<br>f/1.6-f/11（夜景）<br>对焦距离：1m 至无穷远（广角），<br>8m至无穷远（长焦）'],
                    ['广角相机参数', null],
                    ['传感器', '1/2.3" CMOS，有效像素1200万'],
                    ['镜头', 'DFOV：82.9°<br>焦距：4.5mm（等效焦距：24 mm）<br>光圈：f/2.8<br>对焦距离：1m至无穷远'],
                    ['快门速度', '1 ~ 1/8000'],
                    ['视频分辨率', '1920×1080@30fps'],
                    ['最大照片尺寸', '4056×3040'],
                    ['热成像相机', null],
                    ['热成像传感器类型', '非制冷氧化钒（VOx）<br>微测热辐射计'],
                    ['镜头', 'DFOV：40.6°<br>焦距：13.5mm（等效焦距：58mm）<br>光圈：f/1.0<br>对焦距离：5m至无穷远'],
                    ['数字变焦', '1x，2x，4x，8x'],
                    ['视频分辨率', '640×512 @30Hz'],
                    ['照片分辨率', '640×512'],
                    ['像元间距', '12μm'],
                    ['波长范围', '8-14μm'],
                    ['激光测距仪', null],
                    ['波长', '905nm'],
                    ['测量范围', '3-1200m（直径12m、20%<br>反射率的垂直反射面）'],
                    ['测量精度', '±(0.2m+D×0.15%)']
                ]
            }
        ],
    }
}

export const collector = {
    EN: {
        first: {
            title: 'Geographic information collection system - Collector',
            text: 'It is mainly used for high-resolution large-scale geographic information data collection. RTK and PPK dual differential systems provide centimeter-level accuracy results, which can effectively reduce the number of ground image control points. Modular design load can collect multiple types of data, easy and fast operation, support single soldier operation, no remote control and no operator.',
            tips: ['Carbon fiber skeleton throughout the fuselage,  making the aircraft light and sturdy.', 'Smart battery can be quickly and easily installed.', 'The fuselage has LED status lights that make the aircraft be visually displayed.', 'The aircraft can be quickly assembled in two minutes with simple design structure.']
        },
        second: {
            title: 'Easy hand throwing, Efficient operation',
            text: 'Portable transport box, quick toolless disassembly and assembly, can be quickly opened in 5 minutes. No specific environment requirement,  a hand toss to take off, the aircraft will be activated by posture induction, and be immediately start-up with the green light lighting.  With the easy and stale process, the flight system can be fully operated by a single person.'
        },
        third: {
            title: 'Multiple payloads, Multi-purpose machine',
            text: 'Standardized design of Payload Modules can be multi-purposed in a variety of aerial survey. You do not need to use the installation tools，cause the oblique photography, the orthographic photography, and the multichannel spectrometer can be easily interchanged.',
            tips: ['Oblique photography module', 'Orthoimage module', 'Multispectral module']
        },
        forth: {
            title: 'High precision and cm-level accuracy',
            text: 'The collector system is equipped with a new RTK and PPK dual-difference integrated navigation and positioning module, which improves the positioning accuracy to centimeter levels , and significantly enhances the absolute accuracy of POS data. Double differential positioning effectively improves the flying safety of the Collector, and provides high-precision data for Oblique photography  in complex terrains.',
        },
        fifth: {
            title: 'Simple, smart and versatile',
            text: 'The new AirlookPro software simplifies route planning process and speeds up intelligently and reasonably. Flight monitoring has been optimized in the monitoring interface to avoid cluttered data display. Intelligent Flight Assistant “Mr. Xiao Ai” effectively saves the energy of ground operators and makes flying safer and more efficient. Because it integrates its own PPK calculation function and pre-processing of collected images, it will greatly help to improve the efficiency of indoor working.',
            tips: ['Intelligent route', 'PPK solution', 'Assistant XiaoAi']
        },
        params: [
            {
                img: require('@/assets/image/gatherers3/p-plane.png'),
                width: 124,
                title: 'Collector',
                detail: [
                    ['Wing span','2.3m'],
                    ['Length ', '1.1m'],
                    ['Take-off weight', '5.5kg'],
                    ['Load camera', 'SONY A7R II / LingJing C5'],
                    ['Take-off method', 'Hand throw'],
                    ['Land method', 'Parachute'],
                    ['Flight duration','70min'],
                    ['Flight speed', '17m/s'],
                    ['Max flight speed','30m/s'],
                    ['Control radius', '10km'],
                    ['Anti-wind capacity', '≤5级'],
                    ['Anti-rain capacity', 'light rain'],
                    ['Max take-off height', '4500m'],
                    ['Max flying height', '5000m'],
                    ['Operating temperature','-10℃-+40℃'],
                    ['Operating humidity', '<75%']					
                ]
            },{
                img: require('@/assets/image/gatherers3/p-c5.png'),
                title: 'Oblique Photography Camera',
                width: 112,
                detail: [
                    ['Camera model','LingJing C5'],
                    ['Sensor', '23.5x15.6mm(APS-C)'],
                    ['Effective pixels', '120 millions （2400×5）'],
                    ['Lens parameter', 'Orthoimage 25mm prime，Oblique photography 35mm prime'],
                    ['Number of sensors', '5pcs'],
                    ['Min exposure interval', '1s'],
                    ['Storage','320GB（64Gx5）']					
                ]
            },{
                img: require('@/assets/image/gatherers3/p-camera.png'),
                title: 'Orthoimage Camera',
                width: 112,
                detail: [
                    ['Camera model','SONY ILCE-7RM2(A7RII)'],
                    ['Sensor', '35.9×24mm (35mm Full Frame)'],
                    ['Effective pixels', '42.4 millions'],
                    ['Lens parameter', '35mm prime'],
                    ['Storage','64GB (expandable)']					
                ]
            }
        ]
    },
    CN: {
        first: {
            title: '地理信息采集系统-采集者',
            text: '主要用于高分辨率大范围地理信息数据采集。RTK、PPK双差分系统提供厘米级精度成果，可有效减少地面像控点数量。模块化设计载荷可采集多类型数据，操作简易快捷，支持单兵作业，无遥控器无操控手。',
            tips: ['全机身碳纤维骨架，轻巧坚固', '智能电池，安装便捷轻松', '机身LED状态灯,飞机状态直观展示', '整机快装结构，2分钟快速展开']
        },
        second: {
            title: '轻松手抛，高效作业',
            text: '便携运输箱、快速无工具拆装、到场5分钟即可快速展开。低环境要求手抛起飞，姿态感应启动，绿灯即刻出手，轻松稳定，单人即可完成标准作业。'
        },
        third: {
            title: '多元载荷，一机多用',
            text: '标准化的载荷模块设计，支持一机多用，覆盖多种航测作业。无工具拆装，倾斜、正摄、多光谱多模块轻松互换。',
            tips: ['倾斜模块','正射模块', '多光谱模块']
        },
        forth: {
            title: '精"芯"倍至，不差毫厘',
            text: '采集者系统通过搭载全新的RTK、PPK双差分一体的导航定位模块，将定位精度提升至厘米级，显著提高POS数据的绝对精度。双差分定位有效提升了采集者的飞行安全，同时为在复杂地形进行倾斜摄影测量提供了高精度数据。',
        },
        fifth: {
            title: '删繁就简, 智慧全能',
            text: '在全新AirlookPro软件中，我们简化了航线规划的流程，更加智能合理快速。在飞行监控中优化了监控界面，数据展示不再凌乱，智能飞行副驾“小埃助手”将有效节省地面操作人员的精力，让飞行更安全高效。集成了自有PPK解算功能、飞行影像预处理等，将有助于内业处理效率的大幅提升。',
            tips: ['智能航路', 'PPK解算', '小埃助手']
        },
        params: [
            {
                img: require('@/assets/image/gatherers3/p-plane.png'),
                width: 124,
                title: '采集者',
                detail: [
                    ['翼展','2.3m'],
                    ['机长', '1.1m'],
                    ['起飞重量', '5.5kg'],
                    ['载荷相机', '索尼A7R II / 灵境C5'],
                    ['起飞方式', '手抛'],
                    ['降落方式', '伞降'],
                    ['续航时间','70min'],
                    ['巡航速度', '17m/s'],
                    ['最大飞行速度','30m/s'],
                    ['控制半径', '10km'],
                    ['抗风能力', '≤5级'],
                    ['抗雨能力', '小雨'],
                    ['最大起飞高度', '4500m'],
                    ['最大飞行高度', '5000m'],
                    ['使用环境','-10℃-+40℃'],
                    ['工作湿度', '<75%']					
                ]
            },{
                img: require('@/assets/image/gatherers3/p-c5.png'),
                title: '倾斜相机',
                width: 112,
                detail: [
                    ['相机型号','灵境C5'],
                    ['传感器', '23.5x15.6mm(APS-C)'],
                    ['有效像素', '1.2亿 （2400×5）'],
                    ['镜头参数', '正摄25mm定焦，倾斜35mm定焦'],
                    ['传感器数量', '5pcs'],
                    ['最小曝光间隔', '1s'],
                    ['存储空间','320GB（64Gx5）']					
                ]
            },{
                img: require('@/assets/image/gatherers3/p-camera.png'),
                title: '正射相机',
                width: 112,
                detail: [
                    ['相机型号','SONY ILCE-7RM2(A7RII)'],
                    ['传感器尺寸', '35.9×24mm (35mm全画幅)'],
                    ['有效像素', '4240万'],
                    ['镜头参数', '35mm定焦'],
                    ['存储空间','64GB（可拓展）']					
                ]
            }
        ]
    }
}

export const AK1 = {
    EN: {
        second: {
            text: 'AK1 is a low-cost flight controller designed for electric fixed-wing UAV with high performance and high reliability. Six degrees of freedom of MEMS inertial sensors, three-axis magnetic sensor, static pressure sensor, high sensitive GPS receiver are internally set to realize the subminiature flight controller integration. AK1 features in simple operation, light weight, and low maintenance cost, being widely used in electric power, surveying and mapping, agriculture and forestry, surveillance and inspection.'
        },
        third:[
            {
                title: 'Simple planning',
                text: 'According to job requirements and aircraft characteristics, landform map data can be automatic matched, the route can avoid obstacles, route planning can be quickly made in work zones and flight routes can be automatic generated.'
            },
            {
                title: 'Free flight',
                text: 'Autonomous flight controller is supported with flight route being landed in advance to realize automatic launching, scheduled flights and automatic landing. '
            }
        ],
        forth: {
            title: 'Integrated design',
            text: 'Equipment number is reduced with highly integrated design, rich interface resources, attitude sensors, GPS, air pressure sensor, power management integration design to make flight controller system safer and more reliable.'
        },
        fifth: {
            title: 'Safe and stable',
            text: 'Highly reliable industrial components, sensors, high heat and humidity, salt fog, extremely cold, hot test, wide voltage input, and the sensor information redundancy design are adopted to ensure a safe system and a stable flight.'
        },
        sixth: {
            title: 'Intelligent cloud management',
            text: 'Online cloud access is supported and flight controller parameters, flight status and flight data can be remote real-time viewed to monitor UAV operation.',
            tips: ['Remote real-time view the UAV flight controller parameters to monitor UAV operation.', 'Monitor flight attitude in real time']
        },
        paramsTitle: 'AK1 specification',
        params: {            
            'Specification': {
                'IMU sensor': {
                    'Roll angle range': '±180°',
                    'Pitch angle range': '±90°',
                    'Three axis angular velocity range': '±150°/s',
                    'Three axis acceleration range ': '±3g',
                },
                'Magnetic heading sensor': {
                    'Heading angle range': '0~360°'
                },
                'Pressure-altitude sensor': {
                    '10cm resolution range': '1KPa~130KPa'
                },
                'GPS sensor': {
                    'GPS acquisition time': '29s',
                    'GPS positioning accuracy': '2.5m CEP',
                    'GPS update frequency': '4 Hz'
                },
                'Max points': '256 route',
                'Communication interface': [' TL232one channel, RS232two channel', 'Baud rate: 9600，19200，38400，57600，', '115200bps, can be set by software'],
                'Remote control input': 'support SBUS trunk',
                'Steering gear output': '6channels PWM',
                'Digital value': 'DO signal 2 channel, DI signal 1 channel',
                'Analog signal': '2 channel',
                'Data storage': '8MByte',
                'Load control interface': 'Camera control interface  Opto-couplers isolation'
            },
            'Electric parameter': {
                'Power supply': '7～40V (DC input)',
                'Power consumption': '＜4W'
            },
            'Physical property': {
                'Weight': '< 100g',
                'Dimension': '78mm*54mm*23mm'
            },
            'Operating environment': {
                'Storage temperature': '-55ºC～+85ºC',
                'Usage temperature': '-40ºC～+70ºC'
            }
        }
    },
    CN: {
        second: {
            text: 'AK1是一款针对电动固定翼无人机打造的高性能、高可靠性、低成本飞控。AK1内置六自由度MEMS惯性传感器、三轴磁传感器、静压传感器、高灵敏度GPS接收机,实现了飞控的超小型一体化集成。AK1具有使用简单、重量轻、 维护成本低等特点，现已广泛用于电力、测绘、农林、侦察、巡检等领域。'
        },
        third:[
            {
                title: '简易规划',
                text: '根据作业需求和飞机特性，自动匹配地貌地图数据，航路避开障碍物，作业区快速航线规划、自动生成航线。'
            },
            {
                title: '自主飞行',
                text: '支持全自主飞行控制，可预先装载航路，实现自主起飞、预定航线飞行、自主降落。 '
            }
        ],
        forth: {
            title: '一体化设计',
            text: '高集成度设计，接口资源丰富，将姿态传感器、GPS、气压传感器、电源管理一体化设计，减少设备数量，使飞行控制系统更安全、更可靠。'
        },
        fifth: {
            title: '安全稳定',
            text: '采用高可靠性工业级元器件、传感器，高湿热、盐雾、极寒、极热试验，宽电压输入，传感器信息冗余设计、确保系统安全、稳定飞行。'
        },
        sixth: {
            title: '智能云管理',
            text: '支持在线云端接入，可远程实时查看飞控参数，飞行状态，飞行数据，监控无人机作业。',
            tips: ['远程实时查看飞控参数监控无人机作业。', '实时监控飞行姿态']
        },
        paramsTitle: 'AK1 详细参数',
        params: {
            '性能参数': {
                'IMU传感器': {
                    '滚转角度量程': '±180°',
                    '俯仰角度量程': '±90°',
                    '三轴角速度量程': '±150°/s',
                    '三轴加速度量程': '±3g',
                },
                '磁航向传感器': {
                    '航向角度量程': '0~360°'
                },
                '气压传感器': {
                    '10cm分辨率量程': '1KPa~130KPa'
                },
                'GPS传感器': {
                    'GPS捕获时间': '29s',
                    'GPS定位精度': '2.5m CEP',
                    'GPS更新频率': '4 Hz'
                },
                '最大航点数': '256航路点',
                '通信接口': [' TTL232一路，RS232两路', '波特率：9600，19200，38400，57600，', '115200bps，可软件设置 '],
                '遥控器输入': '支持SBUS总线',
                '舵机输出': '6路PWM',
                '数字量': 'DO信号2路，DI信号1路',
                '模拟信号': '2路',
                '数据存储': '8MByte',
                '载荷控制接口': '相机控制接口，光耦隔离'
            },
            '电气参数': {
                '供电': '7～40V （DC输入）',
                '功耗': '＜4W'
            },
            '物理特性': {
                '重量': '< 100g',
                '尺寸': '78mm*54mm*23mm'
            },
            '使用环境': {
                '存储温度': '-55ºC～+85ºC',
                '使用温度': '-40ºC～+70ºC'
            }
        }
    }
}

export const AK2 = {
    EN: {
        second: {
            text: 'AK2 is a low-cost flight controller designed for Oil-drive, medium-long range fixed-wing UAV with high reliability and high performance. Gesture, magnetic heading, static pressure, space velocity sensor, GPS receiver, digital radio and high integrated design are set in AK2 to ensure system reliable. Using PowerPC processor and real-time operating system, AK2 ensures software safety and reliable operation with higher anti-interference ability. Have been tested by hundreds of strict military flight, Ak2 is now widely used in surveying and mapping, investigation, monitoring, power of agriculture and forestry and environmental monitoring.'
        },
        third:[
            {
                title: 'Simple planning',
                text: 'According to job requirements and aircraft characteristics, landform map data can be automatic matched, the route can avoid obstacles, route planning can be quickly made in work zones and flight routes can be automatic generated.'
            },
            {
                title: 'Free flight',
                text: 'Autonomous flight controller is supported with flight route being landed in advance to realize automatic launching, scheduled flights and automatic landing. '
            }
        ],
        forth: {
            title: 'Integrated design',
            text: 'Equipment number is reduced with highly integrated design, rich interface resources, attitude sensors, GPS, air pressure sensor, power management integration design to make flight controller system safer and more reliable.'
        },
        fifth: {
            title: 'Safe and stable',
            text: 'Highly reliable industrial components, sensors, high heat and humidity, salt fog, extremely cold, hot test, wide voltage input, and the sensor information redundancy design are adopted to ensure a safe system and a stable flight.'
        },
        sixth: {
            title: 'Intelligent cloud management',
            text: 'Online cloud access is supported and flight controller parameters, flight status and flight data can be remote real-time viewed to monitor UAV operation.',
            tips: ['Remote real-time view the UAV flight controller parameters to monitor UAV operation.', 'Monitor flight attitude in real time']
        },
        paramsTitle: 'AK2 Specification',
        params: [
            {
                title: 'Specification',
                children: [
                    {
                        title: '',
                        children: [[{name: 'AK2 enhanced version', value: ''}, {name: 'AK2', value: ''}]]
                    },
                    {
                        title: 'IMU sensor',
                        children: [
                            [{name: 'Roll angle range', value: '±180°'}, {name: 'Roll angle range', value: '±180°'}],
                            [{name: 'Pitch angle range', value: '±90°/s'}, {name: 'Pitch angle range', value: '±90°/s'}],
                            [{name: 'Three axis angular velocity range  ', value: '±300°/s'}, {name: 'Three axis angular velocity range  ', value: '±300°/s'}],
                            [{name: 'Three axis acceleration range ', value: '±3g'}, {name: 'Three axis acceleration range ', value: '±3g'}],
                        ]
                    },
                    {
                        title: 'Magnetic heading sensor',
                        children: [
                            [{name: 'Heading angle range', value: '0~360°'}, {name: 'Heading angle range', value: '0~360°'}]
                        ]
                    },
                    {
                        title: 'Pressure-altitude sensor',
                        children: [
                            [{name: '10cm resolution range', value: '1KPa~130KPa'}, {name: '10cm resolution range', value: '1KPa~130KPa'}]
                        ]
                    },
                    {
                        title: 'Airspeed sensor',
                        children: [
                            [{name: '', value: ''}, {name: '', value: ''}]
                        ]
                    },
                    {
                        title: 'GNSS',
                        children: [
                            [{name: 'GPS(support GLONASS)'}, {name: 'GPS'}],
                            [{name: 'Single point positioning longitude: 1.5m'}, {name: 'Single point positioning longitude: 2.5m'}],
                            [{name: 'SBAS positioning longitude: 0.6m'}, {name: 'GPS update frequency: 4 HZ'}],
                            [{name: 'DGPS positioning longitude: 0.4m'}, {name: ''}],
                            [{name: ' Data update frequency: 5HZ(Max 50HZ) '}, {name: ''}],
                        ]
                    },
                    {
                        title: 'RS232',
                        children: [
                            [{name: '2 channel'}, {name: '2 channel'}],
                        ]
                    },
                    {
                        title: 'RS232/RS422',
                        children: [
                            [{name: '4channel, Software can set interface mode'}, {name: '4channel, Software can set interface mode'}],
                        ]
                    },
                    {
                        title: 'CANtrunk',
                        children: [
                            [{name: '2 channel'}, {name: '2 channel'}],
                        ]
                    },
                    {
                        title: 'Remote control input',
                        children: [
                            [{name: 'Support SBUS trunk'}, {name: 'Support SBUS trunk'}],
                        ]
                    },
                    {
                        title: 'PWM or I/O',
                        children: [
                            [{name: '14 accesses can be allocated as PWM or GE I/O'}, {name: '14 accesses can be allocated as PWM or GE I/O'}],
                        ]
                    },
                    {
                        title: 'Analog signal',
                        children: [
                            [{name: '2 channel 12 bit ADC(0~5Vinput)'}, {name: '2 channel 12 bit ADC(0~5Vinput)'}],
                        ]
                    },
                    {
                        title: 'Data storage',
                        children: [
                            [{name: '8MByte'}, {name: '8MByte'}],
                        ]
                    },
                    {
                        title: 'Speed acquisition',
                        children: [
                            [{name: '1 channel'}, {name: '1 channel'}],
                        ]
                    },
                    {
                        title: 'Load control',
                        children: [
                            [{name: 'Camera control interface, Opto-couplers isolation'}, {name: 'Camera control interface, Opto-couplers isolation'}],
                        ]
                    },
                ]
            },
            {   
                title: 'Data transmission',
                children: [
                    {
                        title: 'Frequency',
                        children: [
                            [{name: '900MHZ frequency hopping'}, {name: '900MHZ frequency hopping'}],
                        ]
                    },
                    {
                        title: 'Transmitting power',
                        children: [
                           [{name: '1W(Max)'}, {name: '1W(Max)'}],
                        ]
                    },
                    {
                        title: 'Transmission distance',
                        children: [
                            [{name: '40~100km'}, {name: '30~60km'}],
                        ]
                    }
                ]
            },
            {   
                title: 'Electric parameter',
                children: [
                    {
                        title: 'Power supply',
                        children: [
                            [{name: '9～36V'}, {name: '9～36V'}],
                        ]
                    },
                    {
                        title: 'Power consumption',
                        children: [
                            [{name: '< 3W (Static power consumption, no steering gear connected)'}, {name: '< 3W (Static power consumption, no steering gear connected)'}],
                            [{name: '< 7W (Static power consumption, no steering gear connected)'}, {name: '< 7W (Static power consumption, no steering gear connected)'}]
                        ]
                    }
                ]
            },
            {   
                title: 'Physical property',
                children: [
                    {
                        title: 'Weight',
                        children: [[{name: '350g'}]]
                    },
                    {
                        title: 'Dimension',
                        children: [[{name: '139.8mm*93mm*35.6mm'}]]
                    }
                ]
            },
            {   
                title: 'Operating environment',
                children: [
                    {
                        title: 'Storage temperature',
                        children: [[{name: '-55ºC～+85ºC'}]]
                    },
                    {
                        title: 'Usage temperature',
                        children: [[{name: '-40ºC～+70ºC'}]]
                    }
                ]
            }
        ]
    },
    CN: {
        second: {
            text: 'AK2是一款针对油动、中远程固定翼无人机打造的高可靠性、高性能、低成本飞控。AK2内置姿态、磁航向、静压、空速传感器、GPS接收机以及数传电台，高集成度设计保证了系统的可靠性。AK2采用PowerPC 处理器，运行实时操作系统，确保了软件安全、可靠的运行，并具有较高的抗干扰能力。AK2已经过军方数百架次严格的飞行考核，现已广泛用于测绘、侦查、农林监护、电力、环境监测等领域。 '
        },
        third:[
            {
                title: '简易规划',
                text: '根据作业需求和飞机特性，自动匹配地貌地图数据，航路避开障碍物，作业区快速航线规划、自动生成航线。'
            },
            {
                title: '自主飞行',
                text: '支持全自主飞行控制，可预先装载航路，实现自主起飞、预定航线飞行、自主降落。 '
            }
        ],
        forth: {
            title: '一体化设计',
            text: '高集成度设计，接口资源丰富，将姿态传感器、GPS、气压传感器、电源管理一体化设计，减少设备数量，使飞行控制系统更安全、更可靠。'
        },
        fifth: {
            title: '安全稳定',
            text: '采用高可靠性工业级元器件、传感器，高湿热、盐雾、极寒、极热试验，宽电压输入，传感器信息冗余设计、确保系统安全、稳定飞行。'
        },
        sixth: {
            title: '智能云管理',
            text: '支持在线云端接入，可远程实时查看飞控参数，飞行状态，飞行数据，监控无人机作业。',
            tips: ['远程实时查看飞控参数监控无人机作业。', '实时监控飞行姿态']
        },
        paramsTitle: 'AK2详细参数',
        params: [
            {
                title: '性能参数',
                children: [
                    {
                        title: '',
                        children: [[{name: 'AK2增强版'}, {name: 'AK2'}]]
                    },
                    {
                        title: 'IMU传感器',
                        children: [
                            [{name: '滚转角度量程', value: '±180°'}, {name: '滚转角度量程', value: '±180°'}],
                            [{name: '俯仰角度量程', value: '±90°/s'}, {name: '俯仰角度量程', value: '±90°/s'}],
                            [{name: '三轴角速度量程', value: '±300°/s'}, {name: '三轴角速度量程', value: '±300°/s'}],
                            [{name: '三轴加速度量程', value: '±3g'}, {name: '三轴加速度量程', value: '±3g'}],
                        ]
                    },
                    {
                        title: '磁航向传感器',
                        children: [
                            [{name: '航向角度量程', value: '0~360°'}, {name: '航向角度量程', value: '0~360°'}]
                        ]
                    },
                    {
                        title: '气压高度传感器',
                        children: [
                            [{name: '10cm分辨率量程', value: '1KPa~130KPa'}, {name: '10cm分辨率量程', value: '1KPa~130KPa'}]
                        ]
                    },
                    {
                        title: '空速传感器',
                        children: [
                            [{name: ''}, {name: ''}]
                        ]
                    },
                    {
                        title: 'GNSS',
                        children: [
                            [{name: 'GPS(可支持GLONASS)'}, {name: 'GPS'}],
                            [{name: '单点定位经度：1.5m'}, {name: '单点定位经度：2.5m'}],
                            [{name: 'SBAS定位经度：0.6m'}, {name: 'GPS更新频率：4 HZ'}],
                            [{name: 'DGPS定位经度：0.4m'}, {name: ''}],
                            [{name: ' 数据更新率：5HZ(可最大支持50HZ) '}, {name: ''}],
                        ]
                    },
                    {
                        title: 'RS232',
                        children: [
                            [{name: '2路'}, {name: '2路'}],
                        ]
                    },
                    {
                        title: 'RS232/RS422',
                        children: [
                            [{name: '4路，软件可设置接口模式'},{name: '4路，软件可设置接口模式'}],
                        ]
                    },
                    {
                        title: 'CAN总线',
                        children: [
                            [{name: '2路'}, {name: '2路'}],
                        ]
                    },
                    {
                        title: '遥控器输入',
                        children: [
                            [{name: '支持SBUS总线'}, {name: '支持SBUS总线'}],
                        ]
                    },
                    {
                        title: 'PWM或I/O',
                        children: [
                            [{name: '14个通道，可任意配置为PWM或通用I/O '}, {name: '14个通道，可任意配置为PWM或通用I/O '}],
                        ]
                    },
                    {
                        title: '模拟信号',
                        children: [
                           [{name: '2路12bit ADC(0~5V输入)'}, {name: '2路12bit ADC(0~5V输入)'}],
                        ]
                    },
                    {
                        title: '数据存储',
                        children: [
                            [{name: '8MByte'}, {name: '8MByte'}],
                        ]
                    },
                    {
                        title: '转速采集',
                        children: [
                            [{name: '1路'}, {name: '1路'}],
                        ]
                    },
                    {
                        title: '载荷控制',
                        children: [
                            [{name: '相机控制接口，光耦隔离'}, {name: '相机控制接口，光耦隔离'}],
                        ]
                    },
                ]
            },
            {   
                title: '数传',
                children: [
                    {
                        title: '频率',
                        children: [
                            [{name: '900MHZ跳频'}, {name: '900MHZ跳频'}],
                        ]
                    },
                    {
                        title: '发射功率',
                        children: [
                            [{name: '1W(最大)'}, {name: '1W(最大)'}],
                        ]
                    },
                    {
                        title: '传输距离',
                        children: [
                            [{name: '40~100km'}, {name: '30~60km'}],
                        ]
                    }
                ]
            },
            {   
                title: '电气参数',
                children: [
                    {
                        title: '供电',
                        children: [
                            [{name: '9～36V'}, {name: '9～36V'}],
                        ]
                    },
                    {
                        title: '功耗',
                        children: [
                            [{name: '<3W(静态功耗，不连接舵机)'}, {name: '<3W(静态功耗，不连接舵机)'}],
                            [{name: '<7W(动态功耗，连接舵机)'}, {name: '<7W(动态功耗，连接舵机)'}]
                        ]
                    }
                ]
            },
            {   
                title: '物理特性',
                children: [
                    {
                        title: '重量',
                        children: [[{name: '350g'}]]
                    },
                    {
                        title: '尺寸',
                        children: [[{name: '139.8mm*93mm*35.6mm'}]]
                    }
                ]
            },
            {   
                title: '使用环境',
                children: [
                    {
                        title: '存储温度',
                        children: [[{name: '-55ºC～+85ºC'}]]
                    },
                    {
                        title: '使用温度',
                        children: [[{name: '-40ºC～+70ºC'}]]
                    }
                ]
            }
        ]
    }
}

export const AK3 = {
    EN: {
        second: {
            text: 'AK3 is a flight controller designed for military-level, long-endurance fixed-wing UAVs with high reliability, high performance and high security. Equipped with high accuracy attitude sensors, magnetic heading, static pressure, space velocity sensor, digital radio and double backup GNSS receiver, AK3 has a high level of integration and system reliability. With rich external interface resources, Ak3 can extend all sorts of equipment. Using PowerPC processor and real-time operating system, AK3 ensures software safety and reliable operation with higher anti-interference ability. With high cost performance for flight controller into the industrial sector and acknowledgement by numerous users, Ak3 is now widely used in maritime, military, reconnaissance, electric power, meteorology and other fields.'
        },
        third:[
            {
                title: 'Simple planning',
                text: 'According to job requirements and aircraft characteristics, landform map data can be automatic matched, the route can avoid obstacles, route planning can be quickly made in work zones and flight routes can be automatic generated.'
            },
            {
                title: 'Free flight',
                text: 'Autonomous flight controller is supported with flight route being landed in advance to realize automatic launching, scheduled flights and automatic landing. '
            }
        ],
        forth: {
            title: 'Integrated design',
            text: 'Equipment number is reduced with highly integrated design, rich interface resources, attitude sensors, GPS, air pressure sensor, power management integration design to make flight controller system safer and more reliable.'
        },
        fifth: {
            title: 'Safe and stable',
            text: 'Highly reliable industrial components, sensors, high heat and humidity, salt fog, extremely cold, hot test, wide voltage input, and the sensor information redundancy design are adopted to ensure a safe system and a stable flight.'
        },
        sixth: {
            title: 'Intelligent cloud management',
            text: 'Online cloud access is supported and flight controller parameters, flight status and flight data can be remote real-time viewed to monitor UAV operation.',
            tips: ['Remote real-time view the UAV flight controller parameters to monitor UAV operation.', 'Monitor flight attitude in real time']
        },
        paramsTitle: 'AK3 Specification',
        params: [
            {
                title: 'Specification',
                children: [
                    {
                        title: 'Attitude sensor',
                        children: ['Roll Angle range+180° Dynamic accuracy 0.3 °', 'Pitch Angle range+90°Dynamic accuracy 0.3 °', 'Three axis acceleration range+5g']
                    },
                    {
                        title: 'Magnetic heading sensor',
                        children: ['Heading Angle range  -180°~180° accuracy 1° ']
                    },
                    {
                        title: 'Pressure-altitude sensor',
                        children: ['10cm resolution range:1KPa~130KPa']
                    },
                    {
                        title: 'Airspeed sensor',
                        children: ['']
                    },
                    {
                        title: 'RS232',
                        children: ['2channel']
                    },
                    {
                        title: 'RS232/RS422',
                        children: ['4 channel interface  mode can be installed in the software']
                    },
                    {
                        title: 'CAN trunk',
                        children: ['2channel']
                    },
                    {
                        title: 'Remote control input',
                        children: ['support SBUS trunk']
                    },
                    {
                        title: 'PWM or I/O',
                        children: ['14 accesses can be allocated as PWM or GE I/O']
                    },
                    {
                        title: 'Analog signal',
                        children: ['2 channel 12 bit ADC(0~5Vinput)']
                    },
                    {
                        title: 'Data storage',
                        children: ['8MByte']
                    },
                    {
                        title: 'Speed acquisition',
                        children: ['1channel']
                    },
                    {
                        title: 'Load control',
                        children: ['Camera control interface, Opto-couplers isolation']
                    },
                    {
                        title: 'GNSS',
                        children: ['dual-redundancy GPS(support GLONASS)', 'Single point positioning longitude ：1.5m', 'SBAS positioning longitude：0.6m', 'DGPS positioning longitude：0.4m', 'data update frequency :5 HZ (Max 50 HZ)']
                    },
                    {
                        title: 'Data transmission',
                        children: ['900MHZ frequency hopping', 'transmitting power : 1W(Max)', 'transmission distance: 40~100km']
                    }
                ]
            },
            {
                title: 'Electric parameter',
                children: [
                    {
                        title: 'Power supply',
                        children: ['9~36V']
                    },
                    {
                        title: 'Power consumption',
                        children: ['< 7W (Static power consumption, no steering gear connected)', '< 7W (Static power consumption, no steering gear connected)']
                    }
                ]
            },
            {
                title: 'physical property',
                children: [
                    {
                        title: 'Weight',
                        children: ['350g']
                    },
                    {
                        title: 'Dimension',
                        children: ['139.8mm*93mm*35.6mm']
                    }
                ]
            },
            {
                title: 'Operating environment',
                children: [
                    {
                        title: 'Storage temperature',
                        children: ['-55ºC～+85ºC']
                    },
                    {
                        title: 'Usage temperature',
                        children: ['-40ºC～+70ºC']
                    }
                ]
            }
        ]
    },
    CN: {
        second: {
            text: 'AK3是一款针对军工级大型、长航时固定翼无人机打造的高可靠性、高性能、高安全性飞控。AK3内置高精度姿态传感器、磁航向、静压、空速传感器、数传电台以及双备份GNSS接收机，具有高集成度和出色的系统可靠性。AK3外部具有丰富的接口资源，可扩展各种设备，采用PowerPC 处理器，运行实时操作系统，确保了软件安全、可靠的运行，并具有较高的抗干扰能力。该飞控以高性价比进入工业领域，受到众多用户的肯定，现已广泛用于海事、军事、侦查、电力、气象等领域。'
        },
        third:[
            {
                title: '简易规划',
                text: '根据作业需求和飞机特性，自动匹配地貌地图数据，航路避开障碍物，作业区快速航线规划、自动生成航线。'
            },
            {
                title: '自主飞行',
                text: '支持全自主飞行控制，可预先装载航路，实现自主起飞、预定航线飞行、自主降落。 '
            }
        ],
        forth: {
            title: '一体化设计',
            text: '高集成度设计，接口资源丰富，将姿态传感器、GPS、气压传感器、电源管理一体化设计，减少设备数量，使飞行控制系统更安全、更可靠。'
        },
        fifth: {
            title: '安全稳定',
            text: '采用高可靠性工业级元器件、传感器，高湿热、盐雾、极寒、极热试验，宽电压输入，传感器信息冗余设计、确保系统安全、稳定飞行。'
        },
        sixth: {
            title: '智能云管理',
            text: '支持在线云端接入，可远程实时查看飞控参数，飞行状态，飞行数据，监控无人机作业。',
            tips: ['远程实时查看飞控参数监控无人机作业。', '实时监控飞行姿态']
        },
        paramsTitle: 'AK3详细参数',
        params: [
            {
                title: '性能参数',
                children: [
                    {
                        title: '姿态传感器',
                        children: ['滚转角度量程 ±180° 动态精度0.3°', '俯仰角度量程 ±90° 动态精度0.3°', '三轴加速度量程 ±5g']
                    },
                    {
                        title: '磁航向传感器',
                        children: ['航向角度量程 -180°~180° 精度1° ']
                    },
                    {
                        title: '气压高度传感器',
                        children: ['10cm分辨率量程:1KPa~130KPa']
                    },
                    {
                        title: '空速传感器',
                        children: ['']
                    },
                    {
                        title: 'RS232',
                        children: ['2路']
                    },
                    {
                        title: 'RS232/RS422',
                        children: ['4路，软件可设置接口模式']
                    },
                    {
                        title: 'CAN总线',
                        children: ['2路']
                    },
                    {
                        title: '遥控器输入',
                        children: ['支持SBUS总线']
                    },
                    {
                        title: 'PWM或I/O',
                        children: ['14个通道，可任意配置为PWM或通用I/O ']
                    },
                    {
                        title: '模拟信号',
                        children: ['2路12bit ADC(0~5V输入)']
                    },
                    {
                        title: '数据存储',
                        children: ['8MByte']
                    },
                    {
                        title: '转速采集',
                        children: ['1路']
                    },
                    {
                        title: '载荷控制',
                        children: ['相机控制接口，光耦隔离']
                    },
                    {
                        title: 'GNSS',
                        children: ['双余度GPS(可支持GLONASS)', '单点定位经度：1.5m', 'SBAS定位经度：0.6m', 'DGPS定位经度：0.4m', '数据更新率：5HZ(可最大支持50HZ) ']
                    },
                    {
                        title: '数传',
                        children: ['900MHZ跳频', '1W(最大发射功率)', '传输距离:40~100km']
                    }
                ]
            },
            {
                title: '电气参数',
                children: [
                    {
                        title: '供电',
                        children: ['9~36V']
                    },
                    {
                        title: '功耗',
                        children: ['<3W(静态功耗，不连接舵机)', '<7W(动态功耗，连接舵机)']
                    }
                ]
            },
            {
                title: '物理特性',
                children: [
                    {
                        title: '重量',
                        children: ['350g']
                    },
                    {
                        title: '尺寸',
                        children: ['139.8mm*93mm*35.6mm']
                    }
                ]
            },
            {
                title: '使用环境',
                children: [
                    {
                        title: '存储温度',
                        children: ['-55ºC～+85ºC']
                    },
                    {
                        title: '使用温度',
                        children: ['-40ºC～+70ºC']
                    }
                ]
            }
        ]
    }
}

export const C5 = {
    EN: {
        first: {
            title: 'Lingjing C5-Industry-Oblique photography module camera',
            tips: ['120 million pixels', '850g super lightweight', '6K resolution power lens', 'Suitable for 1: 500 scale measurement', 'Intelligent self-checking after power on', ' Intelligent grouping of image data']
        },
        second: {
            title: 'Small and versatile,  Be your perfect partner',
            text: 'The whole machine has a compact design with palm-sized dimensions, and the weight of only 850g makes the aircraft stress-free. Whether PWM, IO, or Edge, independent trigger can be easily set and be used at any time.',
            tips: [['182','mm','Diameter'],['850', 'g', 'Weight'], ['', '', 'Multi-mode trigger']]
        },
        third: {
            title: 'A clear view of the primitive earth',
            text: 'Restoring the world requires a better lens. The Lingjing C5 is equipped with a 35mm aero-mechanical lens optimized for oblique photography. Imported aspheric lenses have 40% higher resolution than consumer lenses and smaller distortions. It makes the world more real.',
            tips: [['','Imported aspherical lens'],['6k', 'Super high resolution']]
        },
        forth: {
            title: 'Intelligent self-test, Worry-free work',
            text: 'Lingjing C5 has a built-in intelligent self-checking system, which intelligently eliminates common problems of image processing modules, shakes off annoying faults, and settle down to your work.',
        },
        fifth: {
            title: 'The lens stays clean under all conditions',
            text: 'Sand and dust will always adhere to the camera lens and cause wear in bad job sites. The Lingjing C5 adopts a unique industrial design, which protects the lens inside the body through UV mirrors, keeping the lens fresh.',
        },
        sixth: {
            title: 'Convenient with wireless control',
            text: 'Mobile APP supports both IOS and Android devices. WiFi can be used  to connect, debug, set, and monitor the Lingjing C5.',
            tips: ['iOS platform', 'Android platform', 'Wireless connection']
        },
        seventh: {
            title: 'Intelligent Assistant, Convenient and efficient',
            text: 'Lingjing Assistant can easily solve the high-speed data transmission between the  Lingjing C5 and PC. It can transport 1,200 pictures in just three minutes of unattended. Intelligent grouping of aerial data, POS data download, positioning information import, XML file generation can all be implemented with one click. It makes indoor working more efficient.',
            tips: ['High-speed data transmission', 'Intelligent grouping', 'Import the EXIF', 'Project files']
        },
        paramsTitle: 'Lingjing C5 - Technical parameters',
        params: {
            'Sensor parameters': {
                'CCD number': '5pcs',
                'Total pixels': 'More than 120 million',
                'Pixel physical size': '3.9μm',
                'Image resolution': 'Better than 2cm',
                'Side view lens tilt angle': '45°',
                'Min exposure interval': '1sec',
                'CCD size': '23.5mm×15.6mm',
                'Lens focal length': 'Orthoimage 25mm, Oblique Photography 35mm',
                'Storage': '64G×5 (Expandable)',
                'System operation instructions': 'The indicator lights show the working status of the system in real time',
                'Camera power': '36W'
            },
            'Electrical parameters': {
                'Supply voltage': '12V-28V',
                'Operating temperature': '-10℃ to 40℃',
                'Storage temperature': '-20℃ to 50℃',
                'Operating humidity': '<75%',
                'Trigger method': 'Support PWM、IO、Edge、Autonomous trigger',
            },
            'Physical characteristics': {
                'Size': '182mm X 179mm X 89mm',
                'Weight': '850g',
            },
            'Connect Part': {
                'Shock-absorbing ball': '3 / group X4 shock absorber'
            }
        }
    },
    CN: {
        first: {
            title: '灵境C5 — 行业级倾斜摄影相机',
            tips: ['1.2亿像素', '850g超轻量', '6K分辨率镜头', '适用1：500测量', '开机智能自检', '影像数据智能分组']
        },
        second: {
            title: '小巧全能，完美搭档',
            text: '整机紧凑设计，手掌大小尺寸，仅重850g，让飞机毫无压力。无论是PWM、IO、还是Edge、自主独立触发都可轻松设置，告别繁琐，即装即用。',
            tips: [['182','mm','直径'],['850', 'g', '重量'], ['', '', '多模触发']]
        },
        third: {
            title: '看见，清晰还原',
            text: '还原世界需要更卓越的镜头，灵境C5搭载了针对倾斜摄影优化的35mm航空机械镜头。进口非球面镜片，分辨率较消费级镜头提高40%，畸变更小，世界更真实。',
            tips: [['','进口非球面镜片'],['6k', '超高分辨率']]
        },
        forth: {
            title: '智能自检，作业无忧',
            text: '灵境C5内置智能自检系统，针对影像处理模块的常见问题智能排除，甩开恼人的故障，安心作业。',
        },
        fifth: {
            title: '无尘“镜”界，方得始终',
            text: '在糟糕作业场地，沙尘总会附着在相机镜头上造成磨损，灵境C5采用独特的工业设计，通过UV镜将镜头保护在机身内部，让镜头历久弥新。',
        },
        sixth: {
            title: '无线掌控，轻装上阵',
            text: '移动APP同时支持iOS与安卓设备，通过WiFi与灵境C5连接，调试、设置、状态监控尽在掌握。',
            tips: ['iOS平台', '安卓平台', '无线连接']
        },
        seventh: {
            title: '智能助手，便捷高效',
            text: '灵境Assistant可轻松解决灵境C5和PC的高速数据传输，1200张图片传输仅需3分钟，全程无人值守。航片数据智能分组、定位信息导入、XML文件生成一键执行，内业处理更高效。',
            tips: ['高速传输', '智能分组', '导入EXIF', '工程文件']
        },
        paramsTitle: '灵境C5-技术参数',
        params: {
            '传感器参数': {
                'CCD数量': '5pcs',
                '总像素': '大于1.2亿',
                '像元物理尺寸': '3.9μm',
                '影像分辨率': '优于2cm',
                '侧视镜头倾斜角': '45°',
                '最小曝光间隔': '1秒',
                'CCD尺寸': '23.5mm×15.6mm',
                '镜头焦距': '正射25mm，倾斜35mm',
                '存储能力': '64G×5（支持扩展）',
                '系统运行指示': '指示灯实时显示系统工作状态',
                '拍照功率': '36W'
            },
            '电气参数': {
                '供电电压': '12V-28V',
                '工作温度': '-10℃ 至 40℃',
                '存储温度': '-20℃ 至 50℃',
                '工作湿度': '<75%',
                '触发方式': '支持PWM、IO、Edge、自主触发',
            },
            '物理特征': {
                '尺寸': '182mm X 179mm X 89mm',
                '重量': '850g',
            },
            '连接配件': {
                '减震球': '3个/组×4组组成的减震装置'
            }
        }
    }
}

export const space = {
    EN: {
        first: {
            title: 'Urban space management <br>and control system',
            text: "The urban space management and control system covers smart comprehensive governance, smart city management, smart municipal administration, and smart transportation. It uses huge amounts of heterogeneous city data as the core resource and digital twin cities as the base to realize the full-cycle management and control of the whole city and promote the modernization and upgrading of urban governance."
        },
        second: {
            title: 'Digital twin, <br>accurate restoration',
            text: "The full-time, full-domain and full-element mapping of physical space and digital space is accurately restored in the base of the digital twin city，cooperating with the unattended shelter to complete the automatic update of the city's three-dimensional data, and provide a data basis for the city's visual governance and decision-making."
        },
        third: {
            title: 'A better understanding of the whole <br>world，especially cities',
            text: 'Through the city data center to access Internet big data, spatio-temporal big data combined with AIoT physical space platform, in-depth correlation and fusion analysis of huge amounts of heterogeneous data, building a comprehensive urban perception capability, and realizing immediate perception and immediate response of urban governance.'
        },
        forth: {
            title: 'Full cycle, full control',
            text: 'From urban space planning to dynamic construction tracking and then to operation management, the whole process and full coverage of the city area can be visualized and advanced to reduce the internal consumption of the city. Integrate party building, comprehensive management, security inspection, urban management and other grids to build full-element management to help improve the modernization level of urban governance.'
        },
        fifth: {
            title: 'Intelligent mutual trust, <br>data intercommunication',
            text: 'Through technical means such as distributed data storage and sharing structure, smart contracts, data storage and confirmation, complete the establishment of data sharing rules and mechanisms for cross-departmental and cross-industry security and mutual trust, and solve the problem of data islands to realize the interconnection, integration and sharing of urban data resources. '
        }
    },
    CN: {
        first: {
            title: '城市建设监管系统',
            text: "城市建设监管系统，是一套针对大型施工项目建设过程监管的空间可视化管理平台。该平台结合无人机智能巡航系统、空间运算系统，可实现大型施工项目的周期性数字化还原，为建设施工方在项目进度管理上提供决策依据。"
        },
        second: {
            title: '数字孪生，精准还原',
            text: '物理空间与数字空间的全时全域全要素映射，在数字孪生城市底座中精准还原，配合地图无人值守方舱完成对城市三维数据的自动更新，为城市可视化治理、决策提供数据基础。'
        },
        third: {
            title: '全域感知，更懂城市',
            text: '在城市空间规划、动态建设跟踪、监管运营管理方面，实现对市域的全周期、全覆盖的可视化过程精准跟踪，为降低城市内耗、构建高效的城市建设提供重要的信息决策依据，成为提升城市现代化治理的重要抓手。'           
        },
        forth: {
            title: '全周期，全管控',
            text: '在城市空间规划、动态建设跟踪、监管运营管理方面，实现对市域的全周期、全覆盖的可视化过程精准跟踪，为降低城市内耗、构建高效的城市建设提供重要的信息决策依据，成为提升城市现代化治理的重要抓手。'
        },
        fifth: {
            title: '智能互信，数据互通',
            text: '通过分布式数据存储共享结构、智能合约、数据存证和确权等技术手段，<br>完成建立跨部门跨行业安全互信的数据共享规则和机制，解决数据孤岛<br>问题，实现城市数据资源互联互通融合共享。'
        }
    }
}

export const service = {
    EN: {
        first: {
            title: 'Catcher - City low altitude service system',
            text: "The UAV networking system provides governments and enterprises with low-altitude data acquisition, regular<br>inspections, emergency inspections and other services to achieve lower-cost and accurate low-altitude data<br> resource acquisition, and build a smart city with comprehensive perception capabilities.",
            tips: 'more'
        },
        second: {
            title: 'Dense urban drone networking',
            text: 'The urban low-altitude service system realizes full data acquisition, rapid response to emergencies,<br> and no blind spots in inspections by deploying a large number of unattended shelters of the City Catcher <br>in the city.',
            tips: ['City-wide coverage', 'Quick response in 10 minutes', '360° inspection']
        },
        third: {
            title: 'Smart and powerful defense cloud system',
            text: 'The defense cloud is the core of the low-altitude service system, which can realize the intelligent <br>deployment of daily and emergency tasks, and can also provide powerful AI algorithm support for the <br>processing, mining, analysis and prediction of massive data.',
            tips: 'cloud'
        },
        forth: {
            title: 'Wide range of application scenarios',
            text: [
                {
                    title: 'Public safety',
                    text: 'It can realize all-day, high-frequency aerial inspections to supplement traditional monitoring blind spots, reduce labor intensity and labor time, and speed up response to emergencies.',
                    tips: ['AI target recognition shooting', 'Fully autonomous and unmanned', 'Intelligent analysis report']
                },
                {
                    title: 'Safety work',
                    text: 'The progress and quality of the project can be detected through the multi-functional load carried by the drone, and the high-decibel megaphone can be used to manage the safety of the engineering personnel.',
                    tips: ['Engineering change detection', 'Foundation pit displacement detection']
                },
                {
                    title: 'Emergency response',
                    text: 'The UAV networking system covering the whole city can quickly reach the emergency site, allowing multi-level commanders to obtain on-site information more quickly, and gain valuable time for disaster relief.',
                    tips: ['Find missing people faster', 'Fast lighting', 'Stand by 24/7']
                },
                {
                    title: 'Traffic inspection',
                    text: 'Through high-frequency road inspections, the city-wide roads can be monitored, captured, and remotely shouted, reducing the workload of patrolling police officers.',
                    tips: ['High frequency inspection', 'Real-time video return', 'Reduce police pressure']
                },
            ]
        },
        fifth: {
            title: 'Professional Operation Service',
            text: 'Urban low-altitude services are handled by a professional operation team to ensure accurate dispatch of various departments, <br>collect diversified data in the shortest time, and provide data support for efficient response to incidents.',
            tips: ['Give task instructions', 'answer', 'Give command','Go to the mission area', 'Sync data in the cloud', 'Cloud intelligent processing', 'result', 'User obtains demand data']
        }
    },
    CN: {
        first: {
            title: '城市低空服务系统',
            text: "依托部署在城市中的无人机组网系统，为政府、企业提供城市低空数据获取、定期巡检、<br>应急巡查等服务。帮助政企更低成本更高效率获取精准的低空数据资源，助力全市域的空间触达，<br>建设具有全面感知能力的智慧城市。",
            tips: '查看更多'
        },
        second: {
            title: '密集覆盖的城市无人机组网',
            text: '城市低空服务系统通过在城市中部署大量的守望者无人值守方舱，使服务范围覆盖城市的每一个角落，实现数据全域获取、<br> 突发事件快速响应、巡查巡检无死角。让更丰富的低空服务成为可能。',
            tips: ['全域覆盖', '10分钟快速响应', '360°巡检无死角']
        },
        third: {
            title: '智慧强大的防务云系统',
            text: '防务云作为低空服务系统的云上大脑，可以实现日常与应急任务的智能调配，也可以为海量数据的处理、挖掘、<br>分析和预判提供强大的AI算法支撑。',
            tips: '防务云'
        },
        forth: {
            title: '应用场景广泛',
            text: [
                {
                    title: '公共安全',
                    text: '可实现全天候、高频常态空中巡查，有效补充传统监控盲区减轻巡逻警员劳动强度和劳动时间，应急突发时间迅速，加快突发事件的响应速度。',
                    tips: ['AI目标识别拍摄', '全自主无人化', '智能分析上报']
                },
                {
                    title: '安全施工',
                    text: '通过无人机搭载的多功能载荷对工程进展及质量进行检测，同时可利用高分贝喊话器对工程人员进行安全管理。',
                    tips: ['工程变化检测', '基坑位移检测']
                },
                {
                    title: '应急救灾',
                    text: '覆盖全城的无人机组网系统可快速到达应急现场，实时为多级指挥员更快捷地获取现场咨询，为救灾争取到宝贵的时间，让救援工作快速有效地进行。',
                    tips: ['快速寻找失联人员', '快速照明', '全天候待命']
                },
                {
                    title: '交通巡检',
                    text: '通过高频次的道路巡检，对全市域道路执行监控、抓拍与远程劝阻纠正，减轻巡逻警员的劳动强度和劳动时间，实现突发警情快速出警。',
                    tips: ['高频次巡检', '实时视频回传', '减轻警力压力']
                },
            ]
        },
        fifth: {
            title: '专业运营服务',            
            text: '城市低空服务由专业的运营团队负责，保障城市低空服务系统的日常任务、数据运营，在接到任务时可在第一时间满足各部门<br>对无人机平台的调度需求，在最短时间采集多元化数据，为事件的高效响应提供数据支持，提供专业可靠的服务。',
            tips: ['用户通过云端系统/操控台下达任务指令', '下达指令', '系统智能服务', '守望者无人机前往任务区域', '云端实时同步数据', '云端智能处理', '得到结果', '用户获取需求数据']
        }
    }
}